<template>
  <div class="home-box">
    <div id="main"
         data-framer-hydrate-v2="{&quot;routeId&quot;:&quot;augiA20Il&quot;,&quot;localeId&quot;:&quot;default&quot;,&quot;breakpoints&quot;:[{&quot;hash&quot;:&quot;72rtr7&quot;,&quot;mediaQuery&quot;:&quot;(min-width: 1440px)&quot;},{&quot;hash&quot;:&quot;13oz535&quot;,&quot;mediaQuery&quot;:&quot;(min-width: 810px) and (max-width: 1439px)&quot;},{&quot;hash&quot;:&quot;1e8edyz&quot;,&quot;mediaQuery&quot;:&quot;(max-width: 809px)&quot;}]}"
         data-framer-ssr-released-at="2025-01-07T08:43:44.732Z"
         data-framer-page-optimized-at="2025-01-08T20:52:03.160Z">
      <!--$-->
      <div class="framer-orBoP framer-FzGWT framer-FYIBF framer-DSTCA framer-Y8RBt framer-uqalA framer-72rtr7"
           style="min-height:100vh;width:auto">
        <div class="ssr-variant hidden-1e8edyz">
          <div class="framer-tr6jlz-container">
            <div class="framer-CLdFL framer-1rimy18 framer-v-1rimy18" data-framer-name="Desktop"
                 style="background-color: var(--BGHomeColor2, rgb(255, 255, 255)); width: 100%; opacity: 1;">
              <div class="framer-1ng1d4j" data-framer-name="Nav Wrapper" style="opacity: 1;">
                <div class="framer-5lci55-container" style="opacity: 1;">
                  <div class="framer-hvMep framer-FhEkj framer-p3te6o framer-v-p3te6o"
                       data-framer-name="Text Logo" style="height: 100%; opacity: 1;">
                    <img src="./assets/logo.svg" alt="" class="logo">
                    <div class="framer-1cva16v" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--FontColor1, rgb(20, 21, 25)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;">
                      <p class="framer-text framer-styles-preset-ebsdsa" data-styles-preset="jgAaSrIsJ"
                         style="--framer-text-color: var(--extracted-r6o4lv, var(--FontColor1, rgb(20, 21, 25)));">
                        Predi</p></div>
                  </div>
                </div>
                <div class="framer-1e0bhtn" data-framer-name="Right Buttons" style="opacity: 1;">
                  <div class="framer-1f6pfbt" style="opacity: 1;">
                    <div data-framer-component-type="SVG"
                         data-framer-name="Light-off-or-dark-mode-black-sun-21626" class="framer-1d8cgtq"
                         aria-hidden="true" style="image-rendering: pixelated; flex-shrink: 0; opacity: 1;">
                      <div class="svgContainer" style="width: 100%; height: 100%; aspect-ratio: inherit;">
                        <svg style="width:100%;height:100%">
                          <use href="#svg12099793404"></use>
                        </svg>
                      </div>
                    </div>
                    <svg t="1736430142309" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19319" width="30" height="30"><path d="M122.752 487.2H38.336c-12.896 0-23.264 10.336-23.264 23.264s10.368 23.232 23.264 23.232h84.416a23.232 23.232 0 1 0 0-46.496z m93.344-240.672c8.928 8.96 23.616 8.96 32.896 0a23.488 23.488 0 0 0 0-32.896L193.92 158.56a22.912 22.912 0 0 0-32.928 0 22.912 22.912 0 0 0 0 32.896l55.104 55.072z m6.816 521.056l-61.92 61.888a22.912 22.912 0 0 0 0 32.896 23.584 23.584 0 0 0 32.928 0l61.888-61.856a23.584 23.584 0 0 0 0-32.928 22.912 22.912 0 0 0-32.896 0z m290.016-636.224a23.2 23.2 0 0 0 23.264-23.232V35.872c0-12.896-10.368-23.264-23.264-23.264s-23.264 10.368-23.264 23.264v72.256c0 12.864 10.368 23.232 23.264 23.232z m474.24 355.84h-74.048c-12.896 0-23.264 10.336-23.264 23.264s10.368 23.232 23.264 23.232h74.048a23.232 23.232 0 1 0 0-46.496z m-474.24 388.032a23.456 23.456 0 0 0-23.264 23.264v86.176c0 12.896 10.368 23.264 23.264 23.264s23.264-10.368 23.264-23.264v-86.176a23.456 23.456 0 0 0-23.264-23.264z m319.008-716.672l-50.08 49.728a23.488 23.488 0 0 0 0 32.896c9.28 9.28 23.968 9.28 32.928 0l50.08-49.728a23.488 23.488 0 0 0 0-32.896 22.912 22.912 0 0 0-32.928 0z m-24.32 613.696a23.424 23.424 0 0 0-32.896 0 23.488 23.488 0 0 0 0 32.896l57.184 57.216a23.584 23.584 0 0 0 32.928 0 23.488 23.488 0 0 0 0-32.896l-57.216-57.216zM517.92 202.176c-166.304 0-301.504 134.816-301.504 301.12 0 166.656 135.2 301.472 301.504 301.472s301.12-134.816 301.12-301.472c0-166.304-134.848-301.12-301.12-301.12z m0 550.4a249.28 249.28 0 0 1-249.28-249.28 249.44 249.44 0 0 1 199.2-244.288 245.728 245.728 0 0 0-26.464 111.936 249.28 249.28 0 0 0 299.36 244.256 249.408 249.408 0 0 1-222.784 137.344z" fill="#98A2B3" p-id="19320"></path></svg>
                    <div class="framer-17uat6s-container " id="toggle-theme" style="opacity: 1;">
                      <div data-framer-component-type="Frame"   data-framer-cursor="pointer"
                           data-framer-highlight="true"
                           style="display: flex; flex: 0 0 auto; width: 60px; height: 30px; align-items: center; justify-content: space-between; background: rgb(102, 112, 133); border-radius: 15px; cursor: pointer; position: relative; padding: 0px 7.5px; transform: none;">
                        <div data-framer-component-type="Frame"  id="tapLight"
                             style="display: flex; flex: 0 0 auto; pointer-events: none; width: 22.5px; height: 22.5px; background: rgb(255, 255, 255); border-radius: 50%; position: absolute;  transition: left 0.2s; align-items: center; justify-content: center; transform: none;">
                          <div data-framer-component-type="Frame"
                               style="display: block; flex: 0 0 auto; pointer-events: none; width: 22.5px; height: 22.5px; background: transparent; overflow: hidden; transform: none;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                 fill="#000000" width="22.5" height="22.5"></svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="framer-fmso0g-container" style="opacity: 1;"><a
                      class="framer-4MyKO framer-jTQU7 framer-hb8fvd framer-v-hb8fvd framer-1jpqomb"
                       @click="$router.push('/market')" target="_blank" rel="noopener"
                      style="background-color: var(--ButtonColor, rgb(87, 62, 243)); border-radius: 8px; opacity: 1;"
                      data-framer-name="Default ">
                    <div class="framer-duvjkw" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--Color2, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;">
                      <p class="framer-text framer-styles-preset-1e4e6dn" data-styles-preset="fkpfHGzqU"
                         style="--framer-text-color: var(--extracted-r6o4lv, var(--Color2, rgb(255, 255, 255)));">
                        Launch App</p></div>
                  </a></div>
                </div>
              </div>
              <div class="framer-y1li8p" data-framer-name="Bottom Line"
                   style="background-color: var(--token-eb5b0d19-1aa7-4883-8fb0-1863f8bd4814, rgba(0, 0, 0, 0.08)); opacity: 1;"></div>
            </div>
          </div>
        </div>
        <div class="framer-dc0czr" data-framer-name="Hero " name="Hero ">
          <div class="framer-1gn01c3" data-framer-name="Features" name="Features">
            <div class="framer-fugbah">
              <div class="framer-vwq5hc" data-framer-name="Content" name="Content">
                <div class="framer-mdvged" data-framer-name="Text" name="Text">
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-1nuh4qi" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <h1 class="framer-text framer-styles-preset-11whiqz" data-styles-preset="U9NlxW4Kr"
                          style="--framer-text-color: var(--FontColor1, rgb(20, 21, 25));">Your Markets, Your Rules</h1></div>
                  </div>
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-1hxcfed" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <p class="framer-text framer-styles-preset-3hq05c" data-styles-preset="u8FUT4Hlp">The next evolution in prediction markets. Create, trade, and own unique markets
                        powered by blockchain and Licenses.</p></div>
                  </div>
                </div>
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-1ud38pn-container"><a
                      class="framer-4MyKO framer-jTQU7 framer-hb8fvd framer-v-hb8fvd framer-1jpqomb"
                      data-framer-name="Default " @click="$router.push('/market')" target="_blank"
                      rel="noopener"
                      style="background-color: var(--ButtonColor, rgb(87, 62, 243)); border-radius: 8px; opacity: 1;">
                    <div class="framer-duvjkw" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--Color2, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;">
                      <p class="framer-text framer-styles-preset-1e4e6dn" data-styles-preset="fkpfHGzqU"
                         style="--framer-text-color: var(--extracted-r6o4lv, var(--Color2, rgb(255, 255, 255)));">
                        Try Now</p></div>
                  </a></div>
                </div>
              </div>
              <div class="ssr-variant hidden-1e8edyz">
                <div class="framer-jyi5hb" data-framer-name="Image-3" name="Image-3">
                  <div data-framer-background-image-wrapper="true"
                       style="position: absolute; border-radius: inherit; inset: 0px;">
                    <img decoding="async"
                         sizes="calc(min(100vw, 1280px) - 64px)"
                         src="./assets/ZEt3xcZ2oDxmQlSi96MtlqAzA4g.png"
                         alt=""
                         style="display: block; width: 100%; height: 100%; border-radius: inherit; object-position: center center; object-fit: cover;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="framer-r0taek" data-framer-name="Features" name="Features">
          <div class="framer-4uoya3">
            <div class="framer-86dc0b" data-framer-name="Card" name="Card">
              <div class="framer-1tl0fkg">
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-c12ltv-container">
                    <div class="framer-77CqI framer-i8dqe8 framer-v-i8dqe8" data-framer-name="lightning"
                         style="opacity: 1;">
                      <div data-framer-component-type="SVG" data-framer-name="Lightning-01"
                           class="framer-1xzvfyn" aria-hidden="true"
                           style="image-rendering: pixelated; flex-shrink: 0; opacity: 1;">
                        <div class="svgContainer"
                             style="width: 100%; height: 100%; aspect-ratio: inherit;">
                          <img src="./assets/icon1.svg" style="width: 100%" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="framer-1sm049q"
                     style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                     data-framer-component-type="RichTextContainer"><h4
                    class="framer-text framer-styles-preset-10r6fgu" data-styles-preset="BYa1Zf5mG"
                    style="--framer-text-alignment:center;--framer-text-color:var(--FontColor1, rgb(20, 21, 25))">Unleash Your Creativity in Markets</h4></div>
              </div>
              <div class="framer-txgd5a"
                   style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                   data-framer-component-type="RichTextContainer"><p
                  class="framer-text framer-styles-preset-se8omg" data-styles-preset="Al48OrleG"
                  style="--framer-text-alignment:center;--framer-text-color:var(--LineColor, rgb(71, 84, 103))">Predict the future on topics you care about. From global events to niche predictions, your
                imagination is the limit.</p></div>
            </div>
            <div class="framer-18qm87o" data-framer-name="Card" name="Card">
              <div class="framer-1e2fqma">
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-1bi3u82-container">
                    <div class="framer-77CqI framer-i8dqe8 framer-v-ywmx1j" data-framer-name="Cube"
                         style="opacity: 1;">
                      <div data-framer-component-type="SVG" data-framer-name="Cube-01"
                           class="framer-1uq540d" aria-hidden="true"
                           style="image-rendering: pixelated; flex-shrink: 0; opacity: 1;">
                        <div class="svgContainer"
                             style="width: 100%; height: 100%; aspect-ratio: inherit;">
                          <img src="./assets/icon2.svg" style="width: 100%" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="framer-18dq4j"
                     style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                     data-framer-component-type="RichTextContainer"><h4
                    class="framer-text framer-styles-preset-10r6fgu" data-styles-preset="BYa1Zf5mG"
                    style="--framer-text-alignment:center;--framer-text-color:var(--FontColor1, rgb(20, 21, 25))">NFT Ownership for Every Market</h4></div>
              </div>
              <div class="framer-1m625is"
                   style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                   data-framer-component-type="RichTextContainer"><p
                  class="framer-text framer-styles-preset-se8omg" data-styles-preset="Al48OrleG"
                  style="--framer-text-alignment:center;--framer-text-color:var(--LineColor, rgb(71, 84, 103))">Own the markets you create with License-backed security. Each market becomes a unique, tradable
                asset.</p></div>
            </div>
            <div class="framer-pp5ina" data-framer-name="Card" name="Card">
              <div class="framer-41nca2">
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-ncrq9k-container">
                    <div class="framer-77CqI framer-i8dqe8 framer-v-1e3xmxj" data-framer-name="Globe"
                         style="opacity: 1;">
                      <div data-framer-component-type="SVG" data-framer-name="Globe-03"
                           class="framer-14yvx79" aria-hidden="true"
                           style="image-rendering: pixelated; flex-shrink: 0; opacity: 1;">
                        <div class="svgContainer"
                             style="width: 100%; height: 100%; aspect-ratio: inherit;">
                          <img src="./assets/icon3.svg" style="width: 100%" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="framer-113dtmt"
                     style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                     data-framer-component-type="RichTextContainer"><h4
                    class="framer-text framer-styles-preset-10r6fgu" data-styles-preset="BYa1Zf5mG"
                    style="--framer-text-alignment:center;--framer-text-color:var(--FontColor1, rgb(20, 21, 25))">Global Reach, Local Impact</h4></div>
              </div>
              <div class="framer-xjpd6h"
                   style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                   data-framer-component-type="RichTextContainer"><p
                  class="framer-text framer-styles-preset-se8omg" data-styles-preset="Al48OrleG"
                  style="--framer-text-alignment:center;--framer-text-color:var(--LineColor, rgb(71, 84, 103))">Access markets from anywhere in the world. Build a community of traders around the predictions
                you care about most.</p></div>
            </div>
          </div>
        </div>
        <div class="framer-1kmhm5r" data-framer-name="Features Large" name="Features Large">
          <div class="framer-9gwhji" data-framer-name="Features" name="Features">
            <div class="framer-mrme3m">
              <div class="framer-rnu7po" data-framer-name="Image" name="Image">
                <div
                    style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0;background-repeat:repeat;background-position:left top;background-size:126px auto;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTI2IiBoZWlnaHQ9IjEyNiI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0xMjYgMHYyMS41ODRMMjEuNTg0IDEyNkgwdi0xNy41ODVMMTA4LjQxNSAwSDEyNlptMCAxMDguNDE0VjEyNmgtMTcuNTg2TDEyNiAxMDguNDE0Wm0wLTg0djM5LjE3MUw2My41ODUgMTI2SDI0LjQxNEwxMjYgMjQuNDE0Wm0wIDQydjM5LjE3TDEwNS41ODQgMTI2aC0zOS4xN0wxMjYgNjYuNDE0Wk0xMDUuNTg2IDAgMCAxMDUuNTg2VjY2LjQxNUw2Ni40MTUgMGgzOS4xNzFabS00MiAwTDAgNjMuNTg2VjI0LjQxNUwyNC40MTUgMGgzOS4xNzFabS00MiAwTDAgMjEuNTg2VjBoMjEuNTg2WiIvPjwvZGVmcz48dXNlIHhsaW5rOmhyZWY9IiNhIiBmaWxsPSIjODg4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);opacity:0.2"
                    data-framer-background-image-wrapper="true"></div>
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-ovht24" data-framer-name="Image-2" name="Image-2">
                    <div data-framer-background-image-wrapper="true"
                         style="position: absolute; border-radius: inherit; inset: 0px;"><img
                        decoding="async" sizes="min(min(max(100vw, 1px), 1280px) - 64px, 592px)"
                        src="./assets/rKcTJXhSfmf0FQs1ALYwnsxPsto.png"
                        alt=""
                        style="display: block; width: 100%; height: 100%; border-radius: inherit; object-position: center center; object-fit: cover;">
                    </div>
                  </div>
                </div>
              </div>
              <div class="framer-zg8oxa" data-framer-name="Content" name="Content">
                <div class="framer-c40oll" data-framer-name="Text" name="Text">
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-1gun6rd" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <h2 class="framer-text framer-styles-preset-1u9532s" data-styles-preset="DQeyNEuwq"
                          style="--framer-text-color: var(--FontColor1, rgb(20, 21, 25));">Predict the Future, Shape the Outcome</h2></div>
                  </div>
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-1yhefi9" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <p class="framer-text framer-styles-preset-3hq05c" data-styles-preset="u8FUT4Hlp">Join a dynamic platform where your insights matter. Dive into a wide range of
                        prediction markets across trending topics, global events, sports, crypto, and
                        more. Analyze, predict, and profit—all in one place.</p></div>
                  </div>
                </div>
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-cpmi7s-container"><a
                      class="framer-4MyKO framer-jTQU7 framer-hb8fvd framer-v-hb8fvd framer-1jpqomb"
                      data-framer-name="Default " @click="$router.push('/market')" target="_blank"
                      rel="noopener"
                      style="background-color: var(--ButtonColor, rgb(87, 62, 243)); border-radius: 8px; opacity: 1;">
                    <div class="framer-duvjkw" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--Color2, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;">
                      <p class="framer-text framer-styles-preset-1e4e6dn" data-styles-preset="fkpfHGzqU"
                         style="--framer-text-color: var(--extracted-r6o4lv, var(--Color2, rgb(255, 255, 255)));">
                        Predict Outcome</p></div>
                  </a></div>
                </div>
              </div>
            </div>
            <div class="framer-1vc9kwf">
              <div class="framer-1c4oq84" data-framer-name="Content" name="Content">
                <div class="framer-kunj2p" data-framer-name="Text" name="Text">
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-yck9be" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <h2 class="framer-text framer-styles-preset-1u9532s" data-styles-preset="DQeyNEuwq"
                          style="--framer-text-color: var(--FontColor1, rgb(20, 21, 25));">Create Unique Markets, Own the Outcomes</h2></div>
                  </div>
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-1x4gvk2" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <p class="framer-text framer-styles-preset-3hq05c" data-styles-preset="u8FUT4Hlp">Unlike Polymarket, our platform allows you to create your own prediction
                        markets. Each market is minted as an License, granting you unique ownership and
                        control.</p></div>
                  </div>
                </div>
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-c20cm4-container"><a
                      class="framer-4MyKO framer-jTQU7 framer-hb8fvd framer-v-hb8fvd framer-1jpqomb"
                      data-framer-name="Default " @click="$router.push('/nft')"
                      rel="noopener" href="#"
                      style="background-color: var(--ButtonColor, rgb(87, 62, 243)); border-radius: 8px; opacity: 1;">
                    <div class="framer-duvjkw" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--Color2, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;">
                      <p class="framer-text framer-styles-preset-1e4e6dn" data-styles-preset="fkpfHGzqU"
                         style="--framer-text-color: var(--extracted-r6o4lv, var(--Color2, rgb(255, 255, 255)));">
                        Create Market</p></div>
                  </a></div>
                </div>
              </div>
              <div class="framer-1wvu6nw" data-framer-name="Image" name="Image">
                <div
                    style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0;background-repeat:repeat;background-position:left top;background-size:126px auto;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTI2IiBoZWlnaHQ9IjEyNiI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0xMjYgMHYyMS41ODRMMjEuNTg0IDEyNkgwdi0xNy41ODVMMTA4LjQxNSAwSDEyNlptMCAxMDguNDE0VjEyNmgtMTcuNTg2TDEyNiAxMDguNDE0Wm0wLTg0djM5LjE3MUw2My41ODUgMTI2SDI0LjQxNEwxMjYgMjQuNDE0Wm0wIDQydjM5LjE3TDEwNS41ODQgMTI2aC0zOS4xN0wxMjYgNjYuNDE0Wk0xMDUuNTg2IDAgMCAxMDUuNTg2VjY2LjQxNUw2Ni40MTUgMGgzOS4xNzFabS00MiAwTDAgNjMuNTg2VjI0LjQxNUwyNC40MTUgMGgzOS4xNzFabS00MiAwTDAgMjEuNTg2VjBoMjEuNTg2WiIvPjwvZGVmcz48dXNlIHhsaW5rOmhyZWY9IiNhIiBmaWxsPSIjODg4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);opacity:0.2"
                    data-framer-background-image-wrapper="true"></div>
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-gh06l7" data-framer-name="Image-1" name="Image-1">
                    <div data-framer-background-image-wrapper="true"
                         style="position: absolute; border-radius: inherit; inset: 0px;"><img
                        decoding="async" sizes="min(min(max(100vw, 1px), 1280px) - 64px, 592px)"
                        src="./assets/bJb6UVG3xnPLXFOfB7eiNb7ICg.png"
                        alt=""
                        style="display: block; width: 100%; height: 100%; border-radius: inherit; object-position: center center; object-fit: cover;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="framer-ih1cj8">
              <div class="framer-118orua" data-framer-name="Image" name="Image">
                <div
                    style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0;background-repeat:repeat;background-position:left top;background-size:126px auto;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTI2IiBoZWlnaHQ9IjEyNiI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0xMjYgMHYyMS41ODRMMjEuNTg0IDEyNkgwdi0xNy41ODVMMTA4LjQxNSAwSDEyNlptMCAxMDguNDE0VjEyNmgtMTcuNTg2TDEyNiAxMDguNDE0Wm0wLTg0djM5LjE3MUw2My41ODUgMTI2SDI0LjQxNEwxMjYgMjQuNDE0Wm0wIDQydjM5LjE3TDEwNS41ODQgMTI2aC0zOS4xN0wxMjYgNjYuNDE0Wk0xMDUuNTg2IDAgMCAxMDUuNTg2VjY2LjQxNUw2Ni40MTUgMGgzOS4xNzFabS00MiAwTDAgNjMuNTg2VjI0LjQxNUwyNC40MTUgMGgzOS4xNzFabS00MiAwTDAgMjEuNTg2VjBoMjEuNTg2WiIvPjwvZGVmcz48dXNlIHhsaW5rOmhyZWY9IiNhIiBmaWxsPSIjODg4IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);opacity:0.2"
                    data-framer-background-image-wrapper="true"></div>
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-1trgjh2" data-framer-name="Image" name="Image">
                    <div data-framer-background-image-wrapper="true"
                         style="position: absolute; border-radius: inherit; inset: 0px;"><img
                        decoding="async" sizes="min(min(max(100vw, 1px), 1280px) - 64px, 592px)"
                        src="./assets/WqgBs7l2f2jjEwu9wS9f27Xy5NQ.png"
                        alt=""
                        style="display: block; width: 100%; height: 100%; border-radius: inherit; object-position: center center; object-fit: cover;">
                    </div>
                  </div>
                </div>
              </div>
              <div class="framer-6l280y" data-framer-name="Content" name="Content">
                <div class="framer-1lkuf25" data-framer-name="Text" name="Text">
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-1p1bisu" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <h2 class="framer-text framer-styles-preset-1u9532s" data-styles-preset="DQeyNEuwq"
                          style="--framer-text-color: var(--FontColor1, rgb(20, 21, 25));">Create Prediction Markets with Your Own Tokens</h2></div>
                  </div>
                  <div class="ssr-variant hidden-1e8edyz">
                    <div class="framer-kr90c1" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; transform: none;">
                      <p class="framer-text framer-styles-preset-3hq05c" data-styles-preset="u8FUT4Hlp">Launch tailored prediction markets for your community using your own tokens.
                        Predi makes it easy to drive engagement, boost token utility, and foster
                        collaboration with seamless token integration.</p></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="framer-inzceg">
              <div class="framer-1y9g9nh" data-framer-name="Content" name="Content">
                <div class="framer-1cx7moc" data-framer-name="Text" name="Text">
                  <div class="framer-r9ci36"
                       style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                       data-framer-component-type="RichTextContainer"><h2
                      class="framer-text framer-styles-preset-1u9532s" data-styles-preset="DQeyNEuwq"
                      style="--framer-text-alignment:center;--framer-text-color:var(--FontColor1, rgb(20, 21, 25))">Global Access. Decentralized Freedom.</h2></div>
                  <div class="framer-aescoh"
                       style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                       data-framer-component-type="RichTextContainer"><p
                      class="framer-text framer-styles-preset-3hq05c" data-styles-preset="u8FUT4Hlp"
                      style="--framer-text-alignment:center"> Participate in or create markets from
                    anywhere in the world, without centralized gatekeepers. Your market, your rules, your
                    community.</p></div>
                </div>
              </div>
              <div background="[object Object]" class="framer-179jqok" data-framer-name="Image" name="Image">
                <div class="ssr-variant hidden-1e8edyz">
                  <div class="framer-1ld7z3y" data-framer-name="Frame 26" name="Frame 26">
                    <div data-framer-background-image-wrapper="true"
                         style="position: absolute; border-radius: inherit; inset: 0px;">
                      <img
                        decoding="async" sizes="416.5064px"
                        src="./assets/global.svg"
                        alt=""
                        style="display: block; width: 100%; height: 100%; border-radius: inherit; object-position: center center; object-fit: cover;">
                    </div>
                  </div>
                </div>
              </div>
              <div class="ssr-variant hidden-1e8edyz">
                <div class="framer-1fi30kz-container"><a
                    class="framer-4MyKO framer-jTQU7 framer-hb8fvd framer-v-hb8fvd framer-1jpqomb"
                    data-framer-name="Default " @click="$router.push(nft)" target="_blank"
                    rel="noopener"
                    style="background-color: var(--ButtonColor, rgb(87, 62, 243)); border-radius: 8px; opacity: 1;">
                  <div class="framer-duvjkw" data-framer-component-type="RichTextContainer"
                       style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--Color2, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;">
                    <p @click="$router.push('/nft')" class="framer-text framer-styles-preset-1e4e6dn" data-styles-preset="fkpfHGzqU"
                       style="--framer-text-color: var(--extracted-r6o4lv, var(--Color2, rgb(255, 255, 255)));">
                      Create Your Market</p></div>
                </a></div>
              </div>
            </div>
          </div>
        </div>
        <div class="ssr-variant hidden-1e8edyz">
          <div class="framer-1vyxtwr-container">
            <nav class="framer-Z7K0j framer-0tVId framer-Nwuge framer-ho30r2 framer-v-ho30r2" data-border="true"
                 data-framer-name="Desktop"
                 style="--border-bottom-width: 1px; --border-color: rgba(0, 0, 0, 0.08); --border-left-width: 0px; --border-right-width: 0px; --border-style: solid; --border-top-width: 0px; background-color: var(--BGColor0, rgb(249, 250, 251)); width: 100%; opacity: 1;">
              <div class="framer-86rhfr" data-framer-name="Bottom Line"
                   style="background-color: var(--token-eb5b0d19-1aa7-4883-8fb0-1863f8bd4814, rgba(0, 0, 0, 0.08)); opacity: 1;"></div>
              <div class="framer-8lh8s7" data-framer-name="Topbar" style="opacity: 1;">
                <div class="framer-uzb7sv-container" style="opacity: 1;">
                  <div class="framer-hvMep framer-FhEkj framer-p3te6o framer-v-p3te6o"
                       data-framer-name="Text Logo" style="opacity: 1;">
                    <div class="framer-1winbqz" data-framer-name="Logo" style="opacity: 1;">
                      <img src="./assets/logo.svg" alt="" class="logo">
                    </div>
                    <div class="framer-1cva16v" data-framer-component-type="RichTextContainer"
                         style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--FontColor1, rgb(20, 21, 25)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;">
                      <p class="framer-text framer-styles-preset-ebsdsa" data-styles-preset="jgAaSrIsJ"
                         style="--framer-text-color: var(--extracted-r6o4lv, var(--FontColor1, rgb(20, 21, 25)));">
                        Predi</p></div>
                  </div>
                </div>
                <div class="framer-1rmz44" data-framer-name="Links" data-hide-scrollbars="true"
                     style="opacity: 1;">
                  <div class="framer-2giprb" data-framer-component-type="RichTextContainer"
                       style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-efb762cf-bc24-4fbd-92cb-b75ee53fdca8, rgba(255, 255, 255, 0.1)); --framer-paragraph-spacing: 0px; transform: none; opacity: 1;">
                    <p class="framer-text framer-styles-preset-1svxohx" data-styles-preset="BmoJrMbam"
                      >
                      <a class="framer-text framer-styles-preset-17yh2lq" data-styles-preset="a0Ry9JFO_"

                         data-framer-page-link-current="true">Home</a></p></div>
                  <div class="framer-109326g" data-framer-component-type="RichTextContainer"
                       style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-efb762cf-bc24-4fbd-92cb-b75ee53fdca8, rgba(255, 255, 255, 0.1)); --framer-paragraph-spacing: 0px; transform: none; opacity: 1;">
                    <p class="framer-text framer-styles-preset-1svxohx" data-styles-preset="BmoJrMbam"
                       style="--framer-text-color: var(--extracted-r6o4lv, var(--token-efb762cf-bc24-4fbd-92cb-b75ee53fdca8, rgba(255, 255, 255, 0.1)));">
                      <a class="framer-text framer-styles-preset-17yh2lq" data-styles-preset="a0Ry9JFO_"
                          @click="$router.push('/market')" target="_blank" rel="noopener">Markets</a>
                    </p></div>
                  <div class="framer-r94jk2" data-framer-component-type="RichTextContainer"
                       style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-efb762cf-bc24-4fbd-92cb-b75ee53fdca8, rgba(255, 255, 255, 0.1)); --framer-paragraph-spacing: 0px; transform: none; opacity: 1;">
                    <p class="framer-text framer-styles-preset-1svxohx" data-styles-preset="BmoJrMbam"
                       style="--framer-text-color: var(--extracted-r6o4lv, var(--token-efb762cf-bc24-4fbd-92cb-b75ee53fdca8, rgba(255, 255, 255, 0.1)));">
                      <a class="framer-text framer-styles-preset-17yh2lq" data-styles-preset="a0Ry9JFO_"
                          @click="$router.push('/portfolio')" target="_blank"
                         rel="noopener">Portfolio</a></p></div>
                </div>
              </div>
              <div class="framer-7mlggx" style="opacity: 1;">
                <div class="framer-eillf5" data-framer-component-type="RichTextContainer"
                     style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-b6f5e9f5-f1e5-4916-85f5-aefddf0d1516, rgb(102, 112, 133)); --framer-paragraph-spacing: 0px; transform: none; opacity: 1;">
                  <p class="framer-text"
                     style="--font-selector: SW50ZXItTWVkaXVt; --framer-font-size: 15px; --framer-font-weight: 500; --framer-letter-spacing: -0.01em; --framer-line-height: 2em; --framer-text-alignment: left; --framer-text-color: var(--extracted-r6o4lv, var(--token-b6f5e9f5-f1e5-4916-85f5-aefddf0d1516, rgb(102, 112, 133)));">
                    Empowering Visionaries Predicting Futures</p></div>
                <div class="icon-list">
                  <a href="https://x.com/prediorg" target="_black">
                    <img src="@/assets/images/twitter.png" alt="" class="icon">
                  </a>
                  <a href="https://t.me/PrediOfficial" target="_black">
                    <img src="@/assets/images/telegram.png" alt="" class="icon">
                  </a>
                  <!--a href="https://discord.gg/UsVNfk36VK" target="_black">
                    <img src="@/assets/images/discord.svg" alt="" class="icon">
                  </a-->
                  <a href="https://github.com/PrediOrg" target="_black">
                    <img src="@/assets/images/github.png" alt="" class="icon">
                  </a>
                  <a href="https://medium.com/@prediorg" target="_black">
                    <img src="@/assets/images/medium.png"  alt="" class="icon">
                  </a>
                  <!--a href="https://predi.gitbook.io/predi/" target="_black">
                    <img src="@/assets/images/gitbook.png" alt="" class="icon">
                  </a-->
                </div>
              </div>
            </nav>
          </div>
        </div>
        <div class="framer-1h0jahf-container">
          <div
              style="width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center">
            <link rel="stylesheet" href="./assets/hbq2dza.css">
          </div>
        </div>
      </div>
      <div class="framer-orBoP framer-FzGWT framer-FYIBF framer-DSTCA framer-Y8RBt framer-uqalA" id="overlay"></div>
      <!--/$--></div>
    <div id="KerberusLoader"
         style="z-index: 2147483642; position: fixed; display: none; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; height: 100%;">

      <link href="chrome-extension://kglcipoddmbniebnibibkghfijekllbl/ui-loader.css" rel="stylesheet" type="text/css">

      <div class="kr_loader_container">
        <div class="kr_popup_area">
          <div class="kr_loader_content_area">
            <div class="kr_ring">
              <img src="chrome-extension://kglcipoddmbniebnibibkghfijekllbl/logo_loader.png">
              <span></span>
            </div>
            <div class="kr_loader_title">Scanning Website....</div>
            <p class="kr_loader_textup"> Running a security test for</p>
            <p class="kr_loader_textdown">stellar-direction-371276.framer.app</p>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>

export default {
  name: "App",
  methods: {
    goPage(url) {
      window.open(url);
    }
  },
  mounted() {
    const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const div = document.getElementById("tapLight");
    const currentTheme = document.body.getAttribute("data-theme");

    // 切换主题
    if (isDarkMode||currentTheme === "dark") {
      div.style.left = "calc(100% - 26.25px)";  // 第一种样式的 left 值
      document.body.setAttribute("data-theme", "dark");
    }
    document.getElementById("toggle-theme").addEventListener("click", function() {
      const div = document.getElementById("tapLight");
      const currentTheme = document.body.getAttribute("data-theme");
      // 切换主题
      if (currentTheme === "dark") {
        document.body.setAttribute("data-theme", "light");
        div.style.left = "3.75px";  // 第二种样式的 left 值
      } else {
        document.body.setAttribute("data-theme", "dark");
        div.style.left = "calc(100% - 26.25px)";  // 第一种样式的 left 值
      }

    });

  }
};
</script>

<style lang="scss" scoped>

@font-face {
  font-family: 'Inter';
  src: url('./assets/Inter-VariableFont_opsz,wght.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
*{
  font-family: "paralucent", sans-serif!important;
}


.framer-Z7K0j .framer-7mlggx{
  justify-content: space-between!important;
}
@media screen and (max-width: 810px) {
  h1,h2,p{
    text-align: center!important;
  }
  .framer-7mlggx{
    flex-direction: column!important;
  }
}
.icon-list {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;

  a {
    margin-left: 10px;
    width: 30px;
    height: 30px;
    opacity: 0.5;

    .icon {
      width: 30px;
      height: 30px;

    }

    &:hover {
      opacity: 0.9;

      .icon {
      }
    }

    &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(6) {
      .icon {
        width: 26px;
        height: 26px;
        margin-top: 2px;
      }
    }
    &:nth-child(4){
      .icon {
        width: 30px;
        height: 30px;
        margin-top: 1px;
      }
    }
  }

}
.links {
  /*
     Auther: Abdelrhman Said
 */



  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  *:focus,
  *:active {
    outline: none !important;
    -webkit-tap-highlight-color: transparent;
  }

  margin-top: 20px;

  .wrapper {
    display: inline-flex;
    list-style: none;
  }

  .wrapper .icon {
    position: relative;
    background: #393E46;
    border-radius: 50%;
    padding: 15px;
    margin: 10px;
    width: 50px;
    height: 50px;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .wrapper .tooltip {
    position: absolute;
    top: 0;
    font-size: 14px;
    background: var(--MintBGColor);
    color: #ffffff;
    padding: 5px 8px;
    border-radius: 5px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .wrapper .tooltip::before {
    position: absolute;
    content: "";
    height: 8px;
    width: 8px;
    background: var(--MintBGColor);
    bottom: -3px;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .wrapper .icon:hover .tooltip {
    top: -45px;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  .wrapper .icon:hover span,
  .wrapper .icon:hover .tooltip {
    text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.1);
  }

  .wrapper .facebook:hover,
  .wrapper .facebook:hover .tooltip,
  .wrapper .facebook:hover .tooltip::before {
    background: #1877F2;
    color: #ffffff;
  }

  .wrapper .twitter:hover,
  .wrapper .twitter:hover .tooltip,
  .wrapper .twitter:hover .tooltip::before {
    background: #1DA1F2;
    color: #ffffff;
  }

  .wrapper .instagram:hover,
  .wrapper .instagram:hover .tooltip,
  .wrapper .instagram:hover .tooltip::before {
    background: #E4405F;
    color: #ffffff;
  }

  .wrapper .github:hover,
  .wrapper .github:hover .tooltip,
  .wrapper .github:hover .tooltip::before {
    background: var(--FontColor1);;
    color: #ffffff;
  }

  .wrapper .youtube:hover,
  .wrapper .youtube:hover .tooltip,
  .wrapper .youtube:hover .tooltip::before {
    background: #CD201F;
    color: #ffffff;
  }
}

.home-box {
  background-color: #1E1E2E;
  width: 100%;
}


.home-app {
  text-align: center;
  width: 1400px;
  margin: 0 auto;
}

</style>
<style scoped data-framer-css-ssr-minified=""
       data-framer-components="framer-orBoP PropertyOverrides framer-CLdFL framer-hvMep framer-4MyKO framer-77CqI framer-Z7K0j framer-00O76">html, body, #main {
  margin: 0;
  padding: 0;
  box-sizing: border-box
}

:root {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale

}

* {
  box-sizing: border-box;
  -webkit-font-smoothing: inherit
}

h1, h2, h3, h4, h5, h6, p, figure {
  margin: 0
}

body, input, textarea, select, button {
  font-size: 12px;
  font-family: sans-serif
}


#__framer-badge-container {
  position: fixed;
  bottom: 0;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: right;
  pointer-events: none;
  z-index: 314159
}

.__framer-badge {
  pointer-events: auto
}


body {
  --framer-will-change-override: none
}

@supports (background: -webkit-named-image(i)) and (not (grid-template-rows: subgrid)) {
  body {
    --framer-will-change-override: transform
  }
}

[data-framer-component-type] {
  position: absolute
}

[data-framer-component-type=Text] {
  cursor: inherit
}

[data-framer-component-text-autosized] * {
  white-space: pre
}

[data-framer-component-type=Text] > * {
  text-align: var(--framer-text-alignment, start)
}

[data-framer-component-type=Text] span span, [data-framer-component-type=Text] p span, [data-framer-component-type=Text] h1 span, [data-framer-component-type=Text] h2 span, [data-framer-component-type=Text] h3 span, [data-framer-component-type=Text] h4 span, [data-framer-component-type=Text] h5 span, [data-framer-component-type=Text] h6 span {
  display: block
}

[data-framer-component-type=Text] span span span, [data-framer-component-type=Text] p span span, [data-framer-component-type=Text] h1 span span, [data-framer-component-type=Text] h2 span span, [data-framer-component-type=Text] h3 span span, [data-framer-component-type=Text] h4 span span, [data-framer-component-type=Text] h5 span span, [data-framer-component-type=Text] h6 span span {
  display: unset
}

[data-framer-component-type=Text] div div span, [data-framer-component-type=Text] a div span, [data-framer-component-type=Text] span span span, [data-framer-component-type=Text] p span span, [data-framer-component-type=Text] h1 span span, [data-framer-component-type=Text] h2 span span, [data-framer-component-type=Text] h3 span span, [data-framer-component-type=Text] h4 span span, [data-framer-component-type=Text] h5 span span, [data-framer-component-type=Text] h6 span span, [data-framer-component-type=Text] a {
  font-family: var(--font-family);
  font-style: var(--font-style);
  font-weight: min(calc(var(--framer-font-weight-increase, 0) + var(--font-weight, 400)), 900);
  color: var(--text-color);
  letter-spacing: var(--letter-spacing);
  font-size: var(--font-size);
  text-transform: var(--text-transform);
  text-decoration: var(--text-decoration);
  line-height: var(--line-height)
}

[data-framer-component-type=Text] div div span, [data-framer-component-type=Text] a div span, [data-framer-component-type=Text] span span span, [data-framer-component-type=Text] p span span, [data-framer-component-type=Text] h1 span span, [data-framer-component-type=Text] h2 span span, [data-framer-component-type=Text] h3 span span, [data-framer-component-type=Text] h4 span span, [data-framer-component-type=Text] h5 span span, [data-framer-component-type=Text] h6 span span, [data-framer-component-type=Text] a {
  --font-family: var(--framer-font-family);
  --font-style: var(--framer-font-style);
  --font-weight: var(--framer-font-weight);
  --text-color: var(--framer-text-color);
  --letter-spacing: var(--framer-letter-spacing);
  --font-size: var(--framer-font-size);
  --text-transform: var(--framer-text-transform);
  --text-decoration: var(--framer-text-decoration);
  --line-height: var(--framer-line-height)
}

[data-framer-component-type=Text] a, [data-framer-component-type=Text] a div span, [data-framer-component-type=Text] a span span span, [data-framer-component-type=Text] a p span span, [data-framer-component-type=Text] a h1 span span, [data-framer-component-type=Text] a h2 span span, [data-framer-component-type=Text] a h3 span span, [data-framer-component-type=Text] a h4 span span, [data-framer-component-type=Text] a h5 span span, [data-framer-component-type=Text] a h6 span span {
  --font-family: var(--framer-link-font-family, var(--framer-font-family));
  --font-style: var(--framer-link-font-style, var(--framer-font-style));
  --font-weight: var(--framer-link-font-weight, var(--framer-font-weight));
  --text-color: var(--framer-link-text-color, var(--framer-text-color));
  --font-size: var(--framer-link-font-size, var(--framer-font-size));
  --text-transform: var(--framer-link-text-transform, var(--framer-text-transform));
  --text-decoration: var(--framer-link-text-decoration, var(--framer-text-decoration))
}

[data-framer-component-type=Text] a:hover, [data-framer-component-type=Text] a div span:hover, [data-framer-component-type=Text] a span span span:hover, [data-framer-component-type=Text] a p span span:hover, [data-framer-component-type=Text] a h1 span span:hover, [data-framer-component-type=Text] a h2 span span:hover, [data-framer-component-type=Text] a h3 span span:hover, [data-framer-component-type=Text] a h4 span span:hover, [data-framer-component-type=Text] a h5 span span:hover, [data-framer-component-type=Text] a h6 span span:hover {
  --font-family: var(--framer-link-hover-font-family, var(--framer-link-font-family, var(--framer-font-family)));
  --font-style: var(--framer-link-hover-font-style, var(--framer-link-font-style, var(--framer-font-style)));
  --font-weight: var(--framer-link-hover-font-weight, var(--framer-link-font-weight, var(--framer-font-weight)));
  --text-color: var(--framer-link-hover-text-color, var(--framer-link-text-color, var(--framer-text-color)));
  --font-size: var(--framer-link-hover-font-size, var(--framer-link-font-size, var(--framer-font-size)));
  --text-transform: var(--framer-link-hover-text-transform, var(--framer-link-text-transform, var(--framer-text-transform)));
  --text-decoration: var(--framer-link-hover-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration)))
}

[data-framer-component-type=Text].isCurrent a, [data-framer-component-type=Text].isCurrent a div span, [data-framer-component-type=Text].isCurrent a span span span, [data-framer-component-type=Text].isCurrent a p span span, [data-framer-component-type=Text].isCurrent a h1 span span, [data-framer-component-type=Text].isCurrent a h2 span span, [data-framer-component-type=Text].isCurrent a h3 span span, [data-framer-component-type=Text].isCurrent a h4 span span, [data-framer-component-type=Text].isCurrent a h5 span span, [data-framer-component-type=Text].isCurrent a h6 span span {
  --font-family: var(--framer-link-current-font-family, var(--framer-link-font-family, var(--framer-font-family)));
  --font-style: var(--framer-link-current-font-style, var(--framer-link-font-style, var(--framer-font-style)));
  --font-weight: var(--framer-link-current-font-weight, var(--framer-link-font-weight, var(--framer-font-weight)));
  --text-color: var(--framer-link-current-text-color, var(--framer-link-text-color, var(--framer-text-color)));
  --font-size: var(--framer-link-current-font-size, var(--framer-link-font-size, var(--framer-font-size)));
  --text-transform: var(--framer-link-current-text-transform, var(--framer-link-text-transform, var(--framer-text-transform)));
  --text-decoration: var(--framer-link-current-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration)))
}

p.framer-text, div.framer-text, h1.framer-text, h2.framer-text, h3.framer-text, h4.framer-text, h5.framer-text, h6.framer-text, ol.framer-text, ul.framer-text {
  margin: 0;
  padding: 0
}

p.framer-text, div.framer-text, h1.framer-text, h2.framer-text, h3.framer-text, h4.framer-text, h5.framer-text, h6.framer-text, li.framer-text, ol.framer-text, ul.framer-text, span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-blockquote-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;
  font-style: var(--framer-blockquote-font-style, var(--framer-font-style, normal));
  font-weight: var(--framer-blockquote-font-weight, var(--framer-font-weight, 400));
  color: var(--framer-blockquote-text-color, var(--framer-text-color, #000));
  font-size: calc(var(--framer-blockquote-font-size, var(--framer-font-size, 16px)) * var(--framer-font-size-scale, 1));
  letter-spacing: var(--framer-blockquote-letter-spacing, var(--framer-letter-spacing, 0));
  text-transform: var(--framer-blockquote-text-transform, var(--framer-text-transform, none));
  text-decoration: var(--framer-blockquote-text-decoration, var(--framer-text-decoration, none));
  line-height: var(--framer-blockquote-line-height, var(--framer-line-height, 1.2em));
  text-align: var(--framer-blockquote-text-alignment, var(--framer-text-alignment, start));
  -webkit-text-stroke-width: var(--framer-text-stroke-width, initial);
  -webkit-text-stroke-color: var(--framer-text-stroke-color, initial);
  -moz-font-feature-settings: var(--framer-font-open-type-features, initial);
  -webkit-font-feature-settings: var(--framer-font-open-type-features, initial);
  font-feature-settings: var(--framer-font-open-type-features, initial);
  font-variation-settings: var(--framer-font-variation-axes, normal);
  text-wrap: var(--framer-text-wrap-override, var(--framer-text-wrap))
}

.framer-fit-text .framer-text {
  white-space: nowrap;
  white-space-collapse: preserve
}

strong.framer-text {
  font-family: var(--framer-blockquote-font-family-bold, var(--framer-font-family-bold));
  font-style: var(--framer-blockquote-font-style-bold, var(--framer-font-style-bold));
  font-weight: var(--framer-blockquote-font-weight-bold, var(--framer-font-weight-bold, bolder));
  font-variation-settings: var(--framer-blockquote-font-variation-axes-bold, var(--framer-font-variation-axes-bold))
}

em.framer-text {
  font-family: var(--framer-blockquote-font-family-italic, var(--framer-font-family-italic));
  font-style: var(--framer-blockquote-font-style-italic, var(--framer-font-style-italic, italic));
  font-weight: var(--framer-blockquote-font-weight-italic, var(--framer-font-weight-italic));
  font-variation-settings: var(--framer-blockquote-font-variation-axes-italic, var(--framer-font-variation-axes-italic))
}

em.framer-text > strong.framer-text {
  font-family: var(--framer-blockquote-font-family-bold-italic, var(--framer-font-family-bold-italic));
  font-style: var(--framer-blockquote-font-style-bold-italic, var(--framer-font-style-bold-italic, italic));
  font-weight: var(--framer-blockquote-font-weight-bold-italic, var(--framer-font-weight-bold-italic, bolder));
  font-variation-settings: var(--framer-blockquote-font-variation-axes-bold-italic, var(--framer-font-variation-axes-bold-italic))
}

p.framer-text:not(:first-child), div.framer-text:not(:first-child), h1.framer-text:not(:first-child), h2.framer-text:not(:first-child), h3.framer-text:not(:first-child), h4.framer-text:not(:first-child), h5.framer-text:not(:first-child), h6.framer-text:not(:first-child), ol.framer-text:not(:first-child), ul.framer-text:not(:first-child), blockquote.framer-text:not(:first-child), .framer-image.framer-text:not(:first-child) {
  margin-top: var(--framer-blockquote-paragraph-spacing, var(--framer-paragraph-spacing, 0))
}

li.framer-text > ul.framer-text:nth-child(2), li.framer-text > ol.framer-text:nth-child(2) {
  margin-top: 0
}

.framer-text[data-text-fill] {
  display: inline-block;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: max(0em, calc(calc(1.3em - var(--framer-blockquote-line-height, var(--framer-line-height, 1.3em))) / 2));
  margin: min(0em, calc(calc(1.3em - var(--framer-blockquote-line-height, var(--framer-line-height, 1.3em))) / -2))
}

code.framer-text, code.framer-text span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-code-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;;
  font-style: var(--framer-blockquote-font-style, var(--framer-code-font-style, var(--framer-font-style, normal)));
  font-weight: var(--framer-blockquote-font-weight, var(--framer-code-font-weight, var(--framer-font-weight, 400)));
  color: var(--framer-blockquote-text-color, var(--framer-code-text-color, var(--framer-text-color, #000)));
  font-size: calc(var(--framer-blockquote-font-size, var(--framer-font-size, 16px)) * var(--framer-font-size-scale, 1));
  letter-spacing: var(--framer-blockquote-letter-spacing, var(--framer-letter-spacing, 0));
  line-height: var(--framer-blockquote-line-height, var(--framer-line-height, 1.2em))
}

blockquote.framer-text {
  margin-block-start: initial;
  margin-block-end: initial;
  margin-inline-start: initial;
  margin-inline-end: initial;
  unicode-bidi: initial
}

a.framer-text, a.framer-text span.framer-text:not([data-text-fill]), span.framer-text[data-nested-link], span.framer-text[data-nested-link] span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-blockquote-font-family, var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;);
  font-style: var(--framer-blockquote-font-style, var(--framer-link-font-style, var(--framer-font-style, normal)));
  font-weight: var(--framer-blockquote-font-weight, var(--framer-link-font-weight, var(--framer-font-weight, 400)));
  color: var(--framer-blockquote-text-color, var(--framer-link-text-color, var(--framer-text-color, #000)));
  font-size: calc(var(--framer-blockquote-font-size, var(--framer-font-size, 16px)) * var(--framer-font-size-scale, 1));
  text-transform: var(--framer-blockquote-text-transform, var(--framer-link-text-transform, var(--framer-text-transform, none)));
  text-decoration: var(--framer-blockquote-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration, none)));
  cursor: var(--framer-custom-cursors, pointer)
}

code.framer-text a.framer-text, code.framer-text a.framer-text span.framer-text:not([data-text-fill]), code.framer-text span.framer-text[data-nested-link], code.framer-text span.framer-text[data-nested-link] span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-code-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;;
  font-style: var(--framer-blockquote-font-style, var(--framer-code-font-style, var(--framer-font-style, normal)));
  font-weight: var(--framer-blockquote-font-weight, var(--framer-code-font-weight, var(--framer-font-weight, 400)));
  color: var(--framer-blockquote-text-color, var(--framer-link-text-color, var(--framer-code-text-color, var(--framer-text-color, #000))));
  font-size: calc(var(--framer-blockquote-font-size, var(--framer-font-size, 16px)) * var(--framer-font-size-scale, 1))
}

a.framer-text:hover, a.framer-text:hover span.framer-text:not([data-text-fill]), span.framer-text[data-nested-link]:hover, span.framer-text[data-nested-link]:hover span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-link-hover-font-family, var(--framer-blockquote-font-family, var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;));
  font-style: var(--framer-link-hover-font-style, var(--framer-blockquote-font-style, var(--framer-link-font-style, var(--framer-font-style, normal))));
  font-weight: var(--framer-link-hover-font-weight, var(--framer-blockquote-font-weight, var(--framer-link-font-weight, var(--framer-font-weight, 400))));
  color: var(--framer-link-hover-text-color, var(--framer-blockquote-text-color, var(--framer-link-text-color, var(--framer-text-color, #000))));
  font-size: calc(var(--framer-link-hover-font-size, var(--framer-blockquote-font-size, var(--framer-font-size, 16px))) * var(--framer-font-size-scale, 1));
  text-transform: var(--framer-link-hover-text-transform, var(--framer-blockquote-text-transform, var(--framer-link-text-transform, var(--framer-text-transform, none))));
  text-decoration: var(--framer-link-hover-text-decoration, var(--framer-blockquote-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration, none))))
}

code.framer-text a.framer-text:hover, code.framer-text a.framer-text:hover span.framer-text:not([data-text-fill]), code.framer-text span.framer-text[data-nested-link]:hover, code.framer-text span.framer-text[data-nested-link]:hover span.framer-text:not([data-text-fill]) {
  font-family: var(var(--framer-code-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;);
  font-style: var(--framer-blockquote-font-style, var(--framer-code-font-style, var(--framer-font-style, normal)));
  font-weight: var(--framer-blockquote-font-weight, var(--framer-code-font-weight, var(--framer-font-weight, 400)));
  color: var(--framer-link-hover-text-color, var(--framer-blockquote-text-color, var(--framer-link-text-color, var(--framer-code-text-color, var(--framer-text-color, #000)))));
  font-size: calc(var(--framer-link-hover-font-size, var(--framer-blockquote-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px)))) * var(--framer-font-size-scale, 1))
}

a.framer-text[data-framer-page-link-current], a.framer-text[data-framer-page-link-current] span.framer-text:not([data-text-fill]), span.framer-text[data-framer-page-link-current], span.framer-text[data-framer-page-link-current] span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-link-current-font-family, var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;);
  font-style: var(--framer-link-current-font-style, var(--framer-link-font-style, var(--framer-font-style, normal)));
  font-weight: var(--framer-link-current-font-weight, var(--framer-link-font-weight, var(--framer-font-weight, 400)));
  color: var(--framer-link-current-text-color, var(--framer-link-text-color, var(--framer-text-color, #000)));
  font-size: calc(var(--framer-link-current-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px))) * var(--framer-font-size-scale, 1));
  text-transform: var(--framer-link-current-text-transform, var(--framer-link-text-transform, var(--framer-text-transform, none)));
  text-decoration: var(--framer-link-current-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration, none)))
}

code.framer-text a.framer-text[data-framer-page-link-current], code.framer-text a.framer-text[data-framer-page-link-current] span.framer-text:not([data-text-fill]), code.framer-text span.framer-text[data-framer-page-link-current], code.framer-text span.framer-text[data-framer-page-link-current] span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-code-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;;
  font-style: var(--framer-code-font-style, var(--framer-font-style, normal));
  font-weight: var(--framer-code-font-weight, var(--framer-font-weight, 400));
  color: var(--framer-link-current-text-color, var(--framer-link-text-color, var(--framer-code-text-color, var(--framer-text-color, #000))));
  font-size: calc(var(--framer-link-current-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px))) * var(--framer-font-size-scale, 1))
}

a.framer-text[data-framer-page-link-current]:hover, a.framer-text[data-framer-page-link-current]:hover span.framer-text:not([data-text-fill]), span.framer-text[data-framer-page-link-current]:hover, span.framer-text[data-framer-page-link-current]:hover span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-link-hover-font-family, var(--framer-link-current-font-family, var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;));
  font-style: var(--framer-link-hover-font-style, var(--framer-link-current-font-style, var(--framer-link-font-style, var(--framer-font-style, normal))));
  font-weight: var(--framer-link-hover-font-weight, var(--framer-link-current-font-weight, var(--framer-link-font-weight, var(--framer-font-weight, 400))));
  color: var(--framer-link-hover-text-color, var(--framer-link-current-text-color, var(--framer-link-text-color, var(--framer-text-color, #000))));
  font-size: calc(var(--framer-link-hover-font-size, var(--framer-link-current-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px)))) * var(--framer-font-size-scale, 1));
  text-transform: var(--framer-link-hover-text-transform, var(--framer-link-current-text-transform, var(--framer-link-text-transform, var(--framer-text-transform, none))));
  text-decoration: var(--framer-link-hover-text-decoration, var(--framer-link-current-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration, none))))
}

code.framer-text a.framer-text[data-framer-page-link-current]:hover, code.framer-text a.framer-text[data-framer-page-link-current]:hover span.framer-text:not([data-text-fill]), code.framer-text span.framer-text[data-framer-page-link-current]:hover, code.framer-text span.framer-text[data-framer-page-link-current]:hover span.framer-text:not([data-text-fill]) {
  font-family: var(--framer-code-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;;
  font-style: var(--framer-code-font-style, var(--framer-font-style, normal));
  font-weight: var(--framer-code-font-weight, var(--framer-font-weight, 400));
  color: var(--framer-link-hover-text-color, var(--framer-link-current-text-color, var(--framer-link-text-color, var(--framer-code-text-color, var(--framer-text-color, #000)))));
  font-size: calc(var(--framer-link-hover-font-size, var(--framer-link-current-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px)))) * var(--framer-font-size-scale, 1))
}

.framer-image.framer-text {
  display: block;
  max-width: 100%;
  height: auto
}

.text-styles-preset-reset.framer-text {
  --framer-font-family: Inter, Inter Placeholder, sans-serif;
  --framer-font-style: normal;
  --framer-font-weight: 500;
  --framer-text-color: #000;
  --framer-font-size: 16px;
  --framer-letter-spacing: 0;
  --framer-text-transform: none;
  --framer-text-decoration: none;
  --framer-line-height: 1.2em;
  --framer-text-alignment: start;
  --framer-font-open-type-features: normal
}

ol.framer-text {
  --list-style-type: decimal
}

ul.framer-text, ol.framer-text {
  display: table;
  width: 100%
}

li.framer-text {
  display: table-row;
  counter-increment: list-item;
  list-style: none
}

ol.framer-text > li.framer-text:before {
  display: table-cell;
  width: 2.25ch;
  box-sizing: border-box;
  padding-inline-end: .75ch;
  content: counter(list-item, var(--list-style-type)) ".";
  white-space: nowrap
}

ul.framer-text > li.framer-text:before {
  display: table-cell;
  width: 2.25ch;
  box-sizing: border-box;
  padding-inline-end: .75ch;
  content: "\2022"
}

.framer-text-module[style*=aspect-ratio] > :first-child {
  width: 100%
}

@supports not (aspect-ratio: 1) {
  .framer-text-module[style*=aspect-ratio] {
    position: relative
  }
}

@supports not (aspect-ratio: 1) {
  .framer-text-module[style*=aspect-ratio]:before {
    content: "";
    display: block;
    padding-bottom: calc(100% / calc(var(--aspect-ratio)))
  }
}

@supports not (aspect-ratio: 1) {
  .framer-text-module[style*=aspect-ratio] > :first-child {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%
  }
}

[data-framer-component-type=DeprecatedRichText] {
  cursor: inherit
}

[data-framer-component-type=DeprecatedRichText] .text-styles-preset-reset {
  --framer-font-family: Inter, Inter Placeholder, sans-serif;
  --framer-font-style: normal;
  --framer-font-weight: 500;
  --framer-text-color: #000;
  --framer-font-size: 16px;
  --framer-letter-spacing: 0;
  --framer-text-transform: none;
  --framer-text-decoration: none;
  --framer-line-height: 1.2em;
  --framer-text-alignment: start;
  --framer-font-open-type-features: normal;
  --font-variation-settings: normal
}

[data-framer-component-type=DeprecatedRichText] p, [data-framer-component-type=DeprecatedRichText] div, [data-framer-component-type=DeprecatedRichText] h1, [data-framer-component-type=DeprecatedRichText] h2, [data-framer-component-type=DeprecatedRichText] h3, [data-framer-component-type=DeprecatedRichText] h4, [data-framer-component-type=DeprecatedRichText] h5, [data-framer-component-type=DeprecatedRichText] h6 {
  margin: 0;
  padding: 0
}

[data-framer-component-type=DeprecatedRichText] p, [data-framer-component-type=DeprecatedRichText] div, [data-framer-component-type=DeprecatedRichText] h1, [data-framer-component-type=DeprecatedRichText] h2, [data-framer-component-type=DeprecatedRichText] h3, [data-framer-component-type=DeprecatedRichText] h4, [data-framer-component-type=DeprecatedRichText] h5, [data-framer-component-type=DeprecatedRichText] h6, [data-framer-component-type=DeprecatedRichText] li, [data-framer-component-type=DeprecatedRichText] ol, [data-framer-component-type=DeprecatedRichText] ul, [data-framer-component-type=DeprecatedRichText] span:not([data-text-fill]) {
  font-family: var(--framer-font-family, Inter, Inter Placeholder, sans-serif);
  font-style: var(--framer-font-style, normal);
  font-weight: var(--framer-font-weight, 400);
  color: var(--framer-text-color, #000);
  font-size: var(--framer-font-size, 16px);
  letter-spacing: var(--framer-letter-spacing, 0);
  text-transform: var(--framer-text-transform, none);
  text-decoration: var(--framer-text-decoration, none);
  line-height: var(--framer-line-height, 1.2em);
  text-align: var(--framer-text-alignment, start)
}

[data-framer-component-type=DeprecatedRichText] p:not(:first-child), [data-framer-component-type=DeprecatedRichText] div:not(:first-child), [data-framer-component-type=DeprecatedRichText] h1:not(:first-child), [data-framer-component-type=DeprecatedRichText] h2:not(:first-child), [data-framer-component-type=DeprecatedRichText] h3:not(:first-child), [data-framer-component-type=DeprecatedRichText] h4:not(:first-child), [data-framer-component-type=DeprecatedRichText] h5:not(:first-child), [data-framer-component-type=DeprecatedRichText] h6:not(:first-child), [data-framer-component-type=DeprecatedRichText] ol:not(:first-child), [data-framer-component-type=DeprecatedRichText] ul:not(:first-child), [data-framer-component-type=DeprecatedRichText] .framer-image:not(:first-child) {
  margin-top: var(--framer-paragraph-spacing, 0)
}

[data-framer-component-type=DeprecatedRichText] span[data-text-fill] {
  display: inline-block;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent
}

[data-framer-component-type=DeprecatedRichText] a, [data-framer-component-type=DeprecatedRichText] a span:not([data-text-fill]) {
  font-family: var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;;
  font-style: var(--framer-link-font-style, var(--framer-font-style, normal));
  font-weight: var(--framer-link-font-weight, var(--framer-font-weight, 400));
  color: var(--framer-link-text-color, var(--framer-text-color, #000));
  font-size: var(--framer-link-font-size, var(--framer-font-size, 16px));
  text-transform: var(--framer-link-text-transform, var(--framer-text-transform, none));
  text-decoration: var(--framer-link-text-decoration, var(--framer-text-decoration, none))
}

[data-framer-component-type=DeprecatedRichText] a:hover, [data-framer-component-type=DeprecatedRichText] a:hover span:not([data-text-fill]) {
  font-family: var(--framer-link-hover-font-family, var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;);
  font-style: var(--framer-link-hover-font-style, var(--framer-link-font-style, var(--framer-font-style, normal)));
  font-weight: var(--framer-link-hover-font-weight, var(--framer-link-font-weight, var(--framer-font-weight, 400)));
  color: var(--framer-link-hover-text-color, var(--framer-link-text-color, var(--framer-text-color, #000)));
  font-size: var(--framer-link-hover-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px)));
  text-transform: var(--framer-link-hover-text-transform, var(--framer-link-text-transform, var(--framer-text-transform, none)));
  text-decoration: var(--framer-link-hover-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration, none)))
}

[data-framer-component-type=DeprecatedRichText] a[data-framer-page-link-current], [data-framer-component-type=DeprecatedRichText] a[data-framer-page-link-current] span:not([data-text-fill]):not([data-nested-link]) {
  font-family: var(--framer-link-current-font-family, var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;);
  font-style: var(--framer-link-current-font-style, var(--framer-link-font-style, var(--framer-font-style, normal)));
  font-weight: var(--framer-link-current-font-weight, var(--framer-link-font-weight, var(--framer-font-weight, 400)));
  color: var(--framer-link-current-text-color, var(--framer-link-text-color, var(--framer-text-color, #000)));
  font-size: var(--framer-link-current-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px)));
  text-transform: var(--framer-link-current-text-transform, var(--framer-link-text-transform, var(--framer-text-transform, none)));
  text-decoration: var(--framer-link-current-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration, none)))
}

[data-framer-component-type=DeprecatedRichText] a[data-framer-page-link-current]:hover, [data-framer-component-type=DeprecatedRichText] a[data-framer-page-link-current]:hover span:not([data-text-fill]):not([data-nested-link]) {
  font-family: var(--framer-link-hover-font-family, var(--framer-link-current-font-family, var(--framer-link-font-family, var(--framer-font-family,  Inter, Inter Placeholder, sans-serif))!important;));
  font-style: var(--framer-link-hover-font-style, var(--framer-link-current-font-style, var(--framer-link-font-style, var(--framer-font-style, normal))));
  font-weight: var(--framer-link-hover-font-weight, var(--framer-link-current-font-weight, var(--framer-link-font-weight, var(--framer-font-weight, 400))));
  color: var(--framer-link-hover-text-color, var(--framer-link-current-text-color, var(--framer-link-text-color, var(--framer-text-color, #000))));
  font-size: var(--framer-link-hover-font-size, var(--framer-link-current-font-size, var(--framer-link-font-size, var(--framer-font-size, 16px))));
  text-transform: var(--framer-link-hover-text-transform, var(--framer-link-current-text-transform, var(--framer-link-text-transform, var(--framer-text-transform, none))));
  text-decoration: var(--framer-link-hover-text-decoration, var(--framer-link-current-text-decoration, var(--framer-link-text-decoration, var(--framer-text-decoration, none))))
}

[data-framer-component-type=DeprecatedRichText] strong {
  font-weight: bolder
}

[data-framer-component-type=DeprecatedRichText] em {
  font-style: italic
}

[data-framer-component-type=DeprecatedRichText] .framer-image {
  display: block;
  max-width: 100%;
  height: auto
}

[data-framer-component-type=DeprecatedRichText] ul, [data-framer-component-type=DeprecatedRichText] ol {
  display: table;
  width: 100%;
  padding-left: 0;
  margin: 0
}

[data-framer-component-type=DeprecatedRichText] li {
  display: table-row;
  counter-increment: list-item;
  list-style: none
}

[data-framer-component-type=DeprecatedRichText] ol > li:before {
  display: table-cell;
  width: 2.25ch;
  box-sizing: border-box;
  padding-right: .75ch;
  content: counter(list-item) ".";
  white-space: nowrap
}

[data-framer-component-type=DeprecatedRichText] ul > li:before {
  display: table-cell;
  width: 2.25ch;
  box-sizing: border-box;
  padding-right: .75ch;
  content: "\2022"
}

:not([data-framer-generated]) > [data-framer-stack-content-wrapper] > *, :not([data-framer-generated]) > [data-framer-stack-content-wrapper] > [data-framer-component-type], :not([data-framer-generated]) > [data-framer-stack-content-wrapper] > [data-framer-legacy-stack-gap-enabled] > *, :not([data-framer-generated]) > [data-framer-stack-content-wrapper] > [data-framer-legacy-stack-gap-enabled] > [data-framer-component-type] {
  position: relative
}

.flexbox-gap-not-supported [data-framer-legacy-stack-gap-enabled=true] > *, [data-framer-legacy-stack-gap-enabled=true][data-framer-stack-flexbox-gap=false] {
  margin-top: calc(var(--stack-gap-y) / 2);
  margin-bottom: calc(var(--stack-gap-y) / 2);
  margin-right: calc(var(--stack-gap-x) / 2);
  margin-left: calc(var(--stack-gap-x) / 2)
}

[data-framer-stack-content-wrapper][data-framer-stack-gap-enabled=true] {
  row-gap: var(--stack-native-row-gap);
  column-gap: var(--stack-native-column-gap)
}

.flexbox-gap-not-supported [data-framer-stack-content-wrapper][data-framer-stack-gap-enabled=true] {
  row-gap: unset;
  column-gap: unset
}

.flexbox-gap-not-supported [data-framer-stack-direction-reverse=false] [data-framer-legacy-stack-gap-enabled=true] > *:first-child, [data-framer-stack-direction-reverse=false] [data-framer-legacy-stack-gap-enabled=true][data-framer-stack-flexbox-gap=false] > *:first-child, .flexbox-gap-not-supported [data-framer-stack-direction-reverse=true] [data-framer-legacy-stack-gap-enabled=true] > *:last-child, [data-framer-stack-direction-reverse=true] [data-framer-legacy-stack-gap-enabled=true][data-framer-stack-flexbox-gap=false] > *:last-child {
  margin-top: 0;
  margin-left: 0
}

.flexbox-gap-not-supported [data-framer-stack-direction-reverse=false] [data-framer-legacy-stack-gap-enabled=true] > *:last-child, [data-framer-stack-direction-reverse=false] [data-framer-legacy-stack-gap-enabled=true][data-framer-stack-flexbox-gap=false] > *:last-child, .flexbox-gap-not-supported [data-framer-stack-direction-reverse=true] [data-framer-legacy-stack-gap-enabled=true] > *:first-child, [data-framer-stack-direction-reverse=true] [data-framer-legacy-stack-gap-enabled=true][data-framer-stack-flexbox-gap=false] > *:first-child {
  margin-right: 0;
  margin-bottom: 0
}

NavigationContainer [data-framer-component-type=NavigationContainer] > *, [data-framer-component-type=NavigationContainer] > [data-framer-component-type] {
  position: relative
}

[data-framer-component-type=Scroll]::-webkit-scrollbar {
  display: none
}

[data-framer-component-type=ScrollContentWrapper] > * {
  position: relative
}

[data-framer-component-type=NativeScroll] {
  -webkit-overflow-scrolling: touch
}

[data-framer-component-type=NativeScroll] > * {
  position: relative
}

[data-framer-component-type=NativeScroll].direction-both {
  overflow-x: scroll;
  overflow-y: scroll
}

[data-framer-component-type=NativeScroll].direction-vertical {
  overflow-x: hidden;
  overflow-y: scroll
}

[data-framer-component-type=NativeScroll].direction-horizontal {
  overflow-x: scroll;
  overflow-y: hidden
}

[data-framer-component-type=NativeScroll].direction-vertical > * {
  width: 100% !important
}

[data-framer-component-type=NativeScroll].direction-horizontal > * {
  height: 100% !important
}

[data-framer-component-type=NativeScroll].scrollbar-hidden::-webkit-scrollbar {
  display: none
}

[data-framer-component-type=PageContentWrapper] > *, [data-framer-component-type=PageContentWrapper] > [data-framer-component-type] {
  position: relative
}

[data-framer-component-type=DeviceComponent].no-device > * {
  width: 100% !important;
  height: 100% !important
}

[data-is-present=false], [data-is-present=false] * {
  pointer-events: none !important
}

[data-framer-cursor=pointer] {
  cursor: pointer
}

[data-framer-cursor=grab] {
  cursor: grab
}

[data-framer-cursor=grab]:active {
  cursor: grabbing
}

[data-framer-component-type=Frame] *, [data-framer-component-type=Stack] * {
  pointer-events: auto
}

[data-framer-generated] * {
  pointer-events: unset
}

.svgContainer svg {
  display: block
}

[data-reset=button] {
  border-width: 0;
  padding: 0;
  background: none
}

[data-hide-scrollbars=true]::-webkit-scrollbar {
  width: 0px;
  height: 0px
}

[data-hide-scrollbars=true]::-webkit-scrollbar-thumb {
  background: transparent
}

.framer-cursor-none, .framer-cursor-none * {
  cursor: none !important
}

.framer-pointer-events-none, .framer-pointer-events-none * {
  pointer-events: none !important
}

.framer-body-augiA20Il-framer-orBoP {
  background: var(--BGColor0, rgb(249, 250, 251))
}

.framer-orBoP.framer-lux5qc, .framer-orBoP .framer-lux5qc {
  display: block
}

.framer-orBoP.framer-72rtr7 {
  align-content: center;
  align-items: center;
  background-color: var(--BGColor0, #f9fafb);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: flex-start;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 1440px
}

.framer-orBoP .framer-tr6jlz-container {
  flex: none;
  height: auto;
  position: sticky;
  top: 0;
  width: 100%;
  will-change: transform;
  z-index: 10
}

.framer-orBoP .framer-dc0czr {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-1gn01c3 {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 100px;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-fugbah, .framer-orBoP .framer-mrme3m, .framer-orBoP .framer-1vc9kwf, .framer-orBoP .framer-ih1cj8 {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 60px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 96px 32px;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-vwq5hc {
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 48px;
  height: min-content;
  justify-content: center;
  max-width: 564px;
  padding: 0;
  position: relative;
  width: 1px
}

.framer-orBoP .framer-mdvged {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 24px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-1nuh4qi, .framer-orBoP .framer-1sm049q, .framer-orBoP .framer-18dq4j, .framer-orBoP .framer-113dtmt, .framer-orBoP .framer-1gun6rd, .framer-orBoP .framer-yck9be, .framer-orBoP .framer-1p1bisu, .framer-orBoP .framer-r9ci36 {
  --framer-link-text-color: #0099ff;
  --framer-link-text-decoration: underline;
  --framer-paragraph-spacing: 0px;
  flex: none;
  height: auto;
  overflow: visible;
  position: relative;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word
}

.framer-orBoP .framer-1hxcfed, .framer-orBoP .framer-txgd5a, .framer-orBoP .framer-1m625is, .framer-orBoP .framer-xjpd6h, .framer-orBoP .framer-1yhefi9, .framer-orBoP .framer-1x4gvk2, .framer-orBoP .framer-kr90c1, .framer-orBoP .framer-aescoh {
  --framer-paragraph-spacing: 0px;
  flex: none;
  height: auto;
  overflow: visible;
  position: relative;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word
}

.framer-orBoP .framer-1ud38pn-container, .framer-orBoP .framer-c12ltv-container, .framer-orBoP .framer-1bi3u82-container, .framer-orBoP .framer-ncrq9k-container, .framer-orBoP .framer-cpmi7s-container, .framer-orBoP .framer-c20cm4-container, .framer-orBoP .framer-1fi30kz-container {
  flex: none;
  height: auto;
  position: relative;
  width: auto
}

.framer-orBoP .framer-jyi5hb {
  aspect-ratio: 1.3929411764705881 / 1;
  flex: 1 0 0px;
  height: var(--framer-aspect-ratio-supported, 425px);
  overflow: visible;
  position: relative;
  width: 1px
}

.framer-orBoP .framer-r0taek {
  align-content: center;
  align-items: center;
  background-color: var(--BGHomeColor2, #ffffff);
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 60px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 96px 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-4uoya3 {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 32px;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: visible;
  padding: 0 32px;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-86dc0b, .framer-orBoP .framer-18qm87o {
  align-content: center;
  align-items: center;
  background-color: var(--BGColor0, #f9fafb);
  border-radius: 16px;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  height: min-content;
  justify-content: flex-start;
  max-width: 100%;
  padding: 30px;
  position: relative;
  width: 1px
}

.framer-orBoP .framer-1tl0fkg, .framer-orBoP .framer-1e2fqma, .framer-orBoP .framer-41nca2 {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 15px;
  height: min-content;
  justify-content: flex-start;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-pp5ina {
  align-content: center;
  align-items: center;
  align-self: stretch;
  background-color: var(--BGColor0, #f9fafb);
  border-radius: 16px;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  height: auto;
  justify-content: flex-start;
  max-width: 100%;
  padding: 30px;
  position: relative;
  width: 1px
}

.framer-orBoP .framer-1kmhm5r {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-9gwhji {
  align-content: center;
  align-items: center;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 1px
}

.framer-orBoP .framer-rnu7po, .framer-orBoP .framer-1wvu6nw, .framer-orBoP .framer-118orua {
  align-content: center;
  align-items: center;
  aspect-ratio: 1.4265060240963856 / 1;
  border-radius: 20px;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 20px;
  height: var(--framer-aspect-ratio-supported, 415px);
  justify-content: center;
  max-width: 592px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 1px;
  will-change: var(--framer-will-change-override, transform)
}

.framer-orBoP .framer-ovht24, .framer-orBoP .framer-gh06l7, .framer-orBoP .framer-1trgjh2 {
  aspect-ratio: 1.3929411764705881 / 1;
  flex: none;
  height: var(--framer-aspect-ratio-supported, 425px);
  overflow: visible;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-zg8oxa, .framer-orBoP .framer-1c4oq84, .framer-orBoP .framer-6l280y {
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 32px;
  height: min-content;
  justify-content: center;
  max-width: 564px;
  padding: 0;
  position: relative;
  width: 1px
}

.framer-orBoP .framer-c40oll, .framer-orBoP .framer-kunj2p, .framer-orBoP .framer-1lkuf25, .framer-orBoP .framer-1cx7moc {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 16px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-inzceg {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 60px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 96px 32px;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-1y9g9nh {
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 48px;
  height: min-content;
  justify-content: center;
  max-width: 796px;
  padding: 0;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-179jqok {
  align-content: center;
  align-items: center;
  aspect-ratio: 1.4265060240963856 / 1;
  border-radius: 20px;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 20px;
  height: var(--framer-aspect-ratio-supported, 415px);
  justify-content: center;
  max-width: 592px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
  will-change: var(--framer-will-change-override, transform)
}

.framer-orBoP .framer-1ld7z3y {
  aspect-ratio: 1.0036297640653358 / 1;
  flex: 1 0 0px;
  height: 1px;
  overflow: visible;
  position: relative;
  width: var(--framer-aspect-ratio-supported, 417px)
}

.framer-orBoP .framer-1vyxtwr-container {
  flex: none;
  height: auto;
  position: relative;
  width: 100%
}

.framer-orBoP .framer-1h0jahf-container {
  bottom: 0;
  flex: none;
  left: calc(50.00000000000002% - 1440px / 2);
  position: absolute;
  top: 0;
  width: 1440px;
  z-index: -1
}

@supports (background: -webkit-named-image(i)) and (not (scale:1)) {
  .framer-orBoP.framer-72rtr7, .framer-orBoP .framer-dc0czr, .framer-orBoP .framer-1gn01c3, .framer-orBoP .framer-fugbah, .framer-orBoP .framer-vwq5hc, .framer-orBoP .framer-mdvged, .framer-orBoP .framer-r0taek, .framer-orBoP .framer-4uoya3, .framer-orBoP .framer-86dc0b, .framer-orBoP .framer-1tl0fkg, .framer-orBoP .framer-18qm87o, .framer-orBoP .framer-1e2fqma, .framer-orBoP .framer-pp5ina, .framer-orBoP .framer-41nca2, .framer-orBoP .framer-1kmhm5r, .framer-orBoP .framer-9gwhji, .framer-orBoP .framer-mrme3m, .framer-orBoP .framer-rnu7po, .framer-orBoP .framer-zg8oxa, .framer-orBoP .framer-c40oll, .framer-orBoP .framer-1vc9kwf, .framer-orBoP .framer-1c4oq84, .framer-orBoP .framer-kunj2p, .framer-orBoP .framer-1wvu6nw, .framer-orBoP .framer-ih1cj8, .framer-orBoP .framer-118orua, .framer-orBoP .framer-6l280y, .framer-orBoP .framer-1lkuf25, .framer-orBoP .framer-inzceg, .framer-orBoP .framer-1y9g9nh, .framer-orBoP .framer-1cx7moc, .framer-orBoP .framer-179jqok {
    gap: 0px
  }

  .framer-orBoP.framer-72rtr7 > *, .framer-orBoP .framer-9gwhji > * {
    margin: 0
  }

  .framer-orBoP.framer-72rtr7 > :first-child, .framer-orBoP .framer-dc0czr > :first-child, .framer-orBoP .framer-1gn01c3 > :first-child, .framer-orBoP .framer-vwq5hc > :first-child, .framer-orBoP .framer-mdvged > :first-child, .framer-orBoP .framer-r0taek > :first-child, .framer-orBoP .framer-86dc0b > :first-child, .framer-orBoP .framer-1tl0fkg > :first-child, .framer-orBoP .framer-18qm87o > :first-child, .framer-orBoP .framer-1e2fqma > :first-child, .framer-orBoP .framer-pp5ina > :first-child, .framer-orBoP .framer-41nca2 > :first-child, .framer-orBoP .framer-9gwhji > :first-child, .framer-orBoP .framer-rnu7po > :first-child, .framer-orBoP .framer-zg8oxa > :first-child, .framer-orBoP .framer-c40oll > :first-child, .framer-orBoP .framer-1c4oq84 > :first-child, .framer-orBoP .framer-kunj2p > :first-child, .framer-orBoP .framer-1wvu6nw > :first-child, .framer-orBoP .framer-118orua > :first-child, .framer-orBoP .framer-6l280y > :first-child, .framer-orBoP .framer-1lkuf25 > :first-child, .framer-orBoP .framer-inzceg > :first-child, .framer-orBoP .framer-1y9g9nh > :first-child, .framer-orBoP .framer-1cx7moc > :first-child, .framer-orBoP .framer-179jqok > :first-child {
    margin-top: 0
  }

  .framer-orBoP.framer-72rtr7 > :last-child, .framer-orBoP .framer-dc0czr > :last-child, .framer-orBoP .framer-1gn01c3 > :last-child, .framer-orBoP .framer-vwq5hc > :last-child, .framer-orBoP .framer-mdvged > :last-child, .framer-orBoP .framer-r0taek > :last-child, .framer-orBoP .framer-86dc0b > :last-child, .framer-orBoP .framer-1tl0fkg > :last-child, .framer-orBoP .framer-18qm87o > :last-child, .framer-orBoP .framer-1e2fqma > :last-child, .framer-orBoP .framer-pp5ina > :last-child, .framer-orBoP .framer-41nca2 > :last-child, .framer-orBoP .framer-9gwhji > :last-child, .framer-orBoP .framer-rnu7po > :last-child, .framer-orBoP .framer-zg8oxa > :last-child, .framer-orBoP .framer-c40oll > :last-child, .framer-orBoP .framer-1c4oq84 > :last-child, .framer-orBoP .framer-kunj2p > :last-child, .framer-orBoP .framer-1wvu6nw > :last-child, .framer-orBoP .framer-118orua > :last-child, .framer-orBoP .framer-6l280y > :last-child, .framer-orBoP .framer-1lkuf25 > :last-child, .framer-orBoP .framer-inzceg > :last-child, .framer-orBoP .framer-1y9g9nh > :last-child, .framer-orBoP .framer-1cx7moc > :last-child, .framer-orBoP .framer-179jqok > :last-child {
    margin-bottom: 0
  }

  .framer-orBoP .framer-dc0czr > * {
    margin: 5px 0
  }

  .framer-orBoP .framer-1gn01c3 > * {
    margin: 50px 0
  }

  .framer-orBoP .framer-fugbah > *, .framer-orBoP .framer-mrme3m > *, .framer-orBoP .framer-1vc9kwf > *, .framer-orBoP .framer-ih1cj8 > * {
    margin: 0 30px
  }

  .framer-orBoP .framer-fugbah > :first-child, .framer-orBoP .framer-4uoya3 > :first-child, .framer-orBoP .framer-1kmhm5r > :first-child, .framer-orBoP .framer-mrme3m > :first-child, .framer-orBoP .framer-1vc9kwf > :first-child, .framer-orBoP .framer-ih1cj8 > :first-child {
    margin-left: 0
  }

  .framer-orBoP .framer-fugbah > :last-child, .framer-orBoP .framer-4uoya3 > :last-child, .framer-orBoP .framer-1kmhm5r > :last-child, .framer-orBoP .framer-mrme3m > :last-child, .framer-orBoP .framer-1vc9kwf > :last-child, .framer-orBoP .framer-ih1cj8 > :last-child {
    margin-right: 0
  }

  .framer-orBoP .framer-vwq5hc > *, .framer-orBoP .framer-1y9g9nh > * {
    margin: 24px 0
  }

  .framer-orBoP .framer-mdvged > * {
    margin: 12px 0
  }

  .framer-orBoP .framer-r0taek > *, .framer-orBoP .framer-inzceg > * {
    margin: 30px 0
  }

  .framer-orBoP .framer-4uoya3 > * {
    margin: 0 16px
  }

  .framer-orBoP .framer-86dc0b > *, .framer-orBoP .framer-18qm87o > *, .framer-orBoP .framer-pp5ina > * {
    margin: 4px 0
  }

  .framer-orBoP .framer-1tl0fkg > *, .framer-orBoP .framer-1e2fqma > *, .framer-orBoP .framer-41nca2 > * {
    margin: 7.5px 0
  }

  .framer-orBoP .framer-1kmhm5r > * {
    margin: 0 5px
  }

  .framer-orBoP .framer-rnu7po > *, .framer-orBoP .framer-1wvu6nw > *, .framer-orBoP .framer-118orua > *, .framer-orBoP .framer-179jqok > * {
    margin: 10px 0
  }

  .framer-orBoP .framer-zg8oxa > *, .framer-orBoP .framer-1c4oq84 > *, .framer-orBoP .framer-6l280y > * {
    margin: 16px 0
  }

  .framer-orBoP .framer-c40oll > *, .framer-orBoP .framer-kunj2p > *, .framer-orBoP .framer-1lkuf25 > *, .framer-orBoP .framer-1cx7moc > * {
    margin: 8px 0
  }
}

.framer-FzGWT .framer-styles-preset-11whiqz:not(.rich-text-wrapper), .framer-FzGWT .framer-styles-preset-11whiqz.rich-text-wrapper h1 {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 48px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 600;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 600;
  --framer-letter-spacing: -.04em;
  --framer-line-height: 1.1em;
  --framer-paragraph-spacing: 0px;
  --framer-text-alignment: start;
  --framer-text-color: #000000;
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

.framer-FYIBF .framer-styles-preset-3hq05c:not(.rich-text-wrapper), .framer-FYIBF .framer-styles-preset-3hq05c.rich-text-wrapper p {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 20px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 500;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 500;
  --framer-letter-spacing: 0;
  --framer-line-height: 1.6em;
  --framer-paragraph-spacing: 20px;
  --framer-text-alignment: start;
  --framer-text-color: #666666;
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

.framer-DSTCA .framer-styles-preset-10r6fgu:not(.rich-text-wrapper), .framer-DSTCA .framer-styles-preset-10r6fgu.rich-text-wrapper h4 {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 20px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 600;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 600;
  --framer-letter-spacing: -.04em;
  --framer-line-height: 1.4em;
  --framer-paragraph-spacing: 40px;
  --framer-text-alignment: start;
  --framer-text-color: #000000;
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

.framer-Y8RBt .framer-styles-preset-se8omg:not(.rich-text-wrapper), .framer-Y8RBt .framer-styles-preset-se8omg.rich-text-wrapper p {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 16px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 500;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 400;
  --framer-letter-spacing: 0;
  --framer-line-height: 1.6em;
  --framer-paragraph-spacing: 20px;
  --framer-text-alignment: start;
  --framer-text-color: #666666;
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

.framer-uqalA .framer-styles-preset-1u9532s:not(.rich-text-wrapper), .framer-uqalA .framer-styles-preset-1u9532s.rich-text-wrapper h2 {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 36px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 600;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 600;
  --framer-letter-spacing: -.04em;
  --framer-line-height: 1.4em;
  --framer-paragraph-spacing: 40px;
  --framer-text-alignment: start;
  --framer-text-color: #000000;
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

@media (min-width: 810px) and (max-width: 1439px) {
  .framer-body-augiA20Il-framer-orBoP {
    background: var(--BGColor0, rgb(249, 250, 251))
  }

  .framer-orBoP.framer-72rtr7 {
    width: 810px
  }

  .framer-orBoP .framer-jyi5hb, .framer-orBoP .framer-gh06l7, .framer-orBoP .framer-1trgjh2 {
    height: var(--framer-aspect-ratio-supported, 246px)
  }

  .framer-orBoP .framer-4uoya3 {
    flex-direction: column;
    gap: 16px
  }

  .framer-orBoP .framer-86dc0b, .framer-orBoP .framer-18qm87o {
    flex: none;
    width: 100%
  }

  .framer-orBoP .framer-txgd5a, .framer-orBoP .framer-1m625is, .framer-orBoP .framer-xjpd6h {
    max-width: 592px
  }

  .framer-orBoP .framer-pp5ina {
    align-self: unset;
    flex: none;
    height: min-content;
    width: 100%
  }

  .framer-orBoP .framer-rnu7po, .framer-orBoP .framer-1wvu6nw {
    height: var(--framer-aspect-ratio-supported, 241px)
  }

  .framer-orBoP .framer-ovht24 {
    height: var(--framer-aspect-ratio-supported, 247px)
  }

  .framer-orBoP .framer-118orua {
    height: var(--framer-aspect-ratio-supported, 240px)
  }

  @supports (background: -webkit-named-image(i)) and (not (scale:1)) {
    .framer-orBoP .framer-4uoya3 {
      gap: 0px
    }

    .framer-orBoP .framer-4uoya3 > * {
      margin: 8px 0
    }

    .framer-orBoP .framer-4uoya3 > :first-child {
      margin-top: 0
    }

    .framer-orBoP .framer-4uoya3 > :last-child {
      margin-bottom: 0
    }
  }
}

@media (max-width: 809px) {
  .framer-body-augiA20Il-framer-orBoP {
    background: var(--BGColor0, rgb(249, 250, 251))
  }

  .framer-orBoP.framer-72rtr7 {
    width: 390px
  }

  .framer-orBoP .framer-fugbah, .framer-orBoP .framer-4uoya3, .framer-orBoP .framer-1kmhm5r, .framer-orBoP .framer-mrme3m, .framer-orBoP .framer-1vc9kwf, .framer-orBoP .framer-ih1cj8 {
    flex-direction: column
  }

  .framer-orBoP .framer-vwq5hc {
    align-content: center;
    align-items: center;
    flex: none;
    order: 0;
    width: 100%
  }

  .framer-orBoP .framer-jyi5hb {
    flex: none;
    height: var(--framer-aspect-ratio-supported, 234px);
    order: 1;
    width: 100%
  }

  .framer-orBoP .framer-86dc0b, .framer-orBoP .framer-18qm87o, .framer-orBoP .framer-9gwhji, .framer-orBoP .framer-6l280y {
    flex: none;
    width: 100%
  }

  .framer-orBoP .framer-pp5ina {
    align-self: unset;
    flex: none;
    height: min-content;
    width: 100%
  }

  .framer-orBoP .framer-rnu7po, .framer-orBoP .framer-1wvu6nw {
    flex: none;
    height: var(--framer-aspect-ratio-supported, 229px);
    order: 0;
    width: 100%
  }

  .framer-orBoP .framer-ovht24, .framer-orBoP .framer-gh06l7 {
    height: var(--framer-aspect-ratio-supported, 234px)
  }

  .framer-orBoP .framer-zg8oxa, .framer-orBoP .framer-1c4oq84 {
    align-content: center;
    align-items: center;
    flex: none;
    order: 1;
    width: 100%
  }

  .framer-orBoP .framer-118orua {
    flex: none;
    height: var(--framer-aspect-ratio-supported, 229px);
    width: 100%
  }

  .framer-orBoP .framer-1trgjh2 {
    height: var(--framer-aspect-ratio-supported, 235px)
  }

  .framer-orBoP .framer-179jqok {
    height: var(--framer-aspect-ratio-supported, 229px)
  }

  .framer-orBoP .framer-1ld7z3y {
    width: var(--framer-aspect-ratio-supported, 229px)
  }

  @supports (background: -webkit-named-image(i)) and (not (scale:1)) {
    .framer-orBoP .framer-fugbah, .framer-orBoP .framer-4uoya3, .framer-orBoP .framer-1kmhm5r, .framer-orBoP .framer-mrme3m, .framer-orBoP .framer-1vc9kwf, .framer-orBoP .framer-ih1cj8 {
      gap: 0px
    }

    .framer-orBoP .framer-fugbah > *, .framer-orBoP .framer-mrme3m > *, .framer-orBoP .framer-1vc9kwf > *, .framer-orBoP .framer-ih1cj8 > * {
      margin: 30px 0
    }

    .framer-orBoP .framer-fugbah > :first-child, .framer-orBoP .framer-4uoya3 > :first-child, .framer-orBoP .framer-1kmhm5r > :first-child, .framer-orBoP .framer-mrme3m > :first-child, .framer-orBoP .framer-1vc9kwf > :first-child, .framer-orBoP .framer-ih1cj8 > :first-child {
      margin-top: 0
    }

    .framer-orBoP .framer-fugbah > :last-child, .framer-orBoP .framer-4uoya3 > :last-child, .framer-orBoP .framer-1kmhm5r > :last-child, .framer-orBoP .framer-mrme3m > :last-child, .framer-orBoP .framer-1vc9kwf > :last-child, .framer-orBoP .framer-ih1cj8 > :last-child {
      margin-bottom: 0
    }

    .framer-orBoP .framer-4uoya3 > * {
      margin: 16px 0
    }

    .framer-orBoP .framer-1kmhm5r > * {
      margin: 5px 0
    }
  }
}

.framer-CLdFL.framer-izkiwy, .framer-CLdFL .framer-izkiwy {
  display: block
}

.framer-CLdFL.framer-1rimy18 {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0px;
  height: 72px;
  justify-content: center;
  overflow: visible;
  padding: 20px 0;
  position: relative;
  width: 1440px
}

.framer-CLdFL .framer-1ng1d4j {
  align-content: center;
  align-items: center;
  display: flex;
  flex: 1 0 0px;
  flex-direction: row;
  flex-wrap: nowrap;
  height: min-content;
  justify-content: space-between;
  max-width: 1280px;
  overflow: visible;
  padding: 0 15px;
  position: relative;
  width: 1px
}

.framer-CLdFL .framer-5lci55-container {
  flex: none;
  height: 32px;
  position: relative;
  width: auto
}

.framer-CLdFL .framer-1e0bhtn {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 16px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: min-content
}

.framer-CLdFL .framer-1f6pfbt {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 12px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 0;
  position: relative;
  width: min-content
}

.framer-CLdFL .framer-1d8cgtq {
  flex: none;
  height: 24px;
  position: relative;
  width: 24px
}

.framer-CLdFL .framer-17uat6s-container, .framer-CLdFL .framer-fmso0g-container {
  flex: none;
  height: auto;
  position: relative;
  width: auto
}

.framer-CLdFL .framer-y1li8p {
  bottom: 0;
  flex: none;
  height: 1px;
  left: 0;
  overflow: visible;
  position: absolute;
  right: 0;
  z-index: 1
}

@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) {
  .framer-CLdFL.framer-1rimy18, .framer-CLdFL .framer-1e0bhtn, .framer-CLdFL .framer-1f6pfbt {
    gap: 0px
  }

  .framer-CLdFL.framer-1rimy18 > * {
    margin: 0
  }

  .framer-CLdFL.framer-1rimy18 > :first-child, .framer-CLdFL .framer-1e0bhtn > :first-child, .framer-CLdFL .framer-1f6pfbt > :first-child {
    margin-left: 0
  }

  .framer-CLdFL.framer-1rimy18 > :last-child, .framer-CLdFL .framer-1e0bhtn > :last-child, .framer-CLdFL .framer-1f6pfbt > :last-child {
    margin-right: 0
  }

  .framer-CLdFL .framer-1e0bhtn > * {
    margin: 0 8px
  }

  .framer-CLdFL .framer-1f6pfbt > * {
    margin: 0 6px
  }
}

.framer-CLdFL.framer-v-1efgf59.framer-1rimy18 {
  width: 810px
}

.framer-CLdFL.framer-v-1efgf59 .framer-1ng1d4j {
  flex: none;
  width: 730px
}

.framer-CLdFL.framer-v-xj5zeu.framer-1rimy18 {
  flex-direction: column;
  width: 390px
}

.framer-CLdFL.framer-v-xj5zeu .framer-1ng1d4j {
  flex: none;
  padding: 0 12px;
  width: 90%
}

@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) {
  .framer-CLdFL.framer-v-xj5zeu.framer-1rimy18 {
    gap: 0px
  }

  .framer-CLdFL.framer-v-xj5zeu.framer-1rimy18 > * {
    margin: 0
  }

  .framer-CLdFL.framer-v-xj5zeu.framer-1rimy18 > :first-child {
    margin-top: 0
  }

  .framer-CLdFL.framer-v-xj5zeu.framer-1rimy18 > :last-child {
    margin-bottom: 0
  }
}

.framer-77CqI.framer-1s51tnx, .framer-77CqI .framer-1s51tnx {
  display: block
}

.framer-77CqI.framer-i8dqe8 {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: 40px;
  justify-content: center;
  padding: 0;
  position: relative;
  width: 40px
}

.framer-77CqI .framer-1xzvfyn, .framer-77CqI .framer-1uq540d, .framer-77CqI .framer-14yvx79 {
  flex: none;
  height: 40px;
  position: relative;
  width: 40px
}

@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) {
  .framer-77CqI.framer-i8dqe8 {
    gap: 0px
  }

  .framer-77CqI.framer-i8dqe8 > * {
    margin: 0 5px
  }

  .framer-77CqI.framer-i8dqe8 > :first-child {
    margin-left: 0
  }

  .framer-77CqI.framer-i8dqe8 > :last-child {
    margin-right: 0
  }
}

.framer-77CqI.framer-v-ywmx1j.framer-i8dqe8, .framer-77CqI.framer-v-1e3xmxj.framer-i8dqe8 {
  aspect-ratio: 1 / 1;
  height: var(--framer-aspect-ratio-supported, 40px)
}

.framer-4MyKO.framer-1jpqomb, .framer-4MyKO .framer-1jpqomb {
  display: block
}

.framer-4MyKO.framer-hb8fvd {
  align-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  padding: 10px 16px;
  position: relative;
  text-decoration: none;
  width: min-content
}

.framer-4MyKO .framer-duvjkw {
  flex: none;
  height: auto;
  position: relative;
  white-space: pre;
  width: auto
}

@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) {
  .framer-4MyKO.framer-hb8fvd {
    gap: 0px
  }

  .framer-4MyKO.framer-hb8fvd > * {
    margin: 5px 0
  }

  .framer-4MyKO.framer-hb8fvd > :first-child {
    margin-top: 0
  }

  .framer-4MyKO.framer-hb8fvd > :last-child {
    margin-bottom: 0
  }
}

.framer-jTQU7 .framer-styles-preset-1e4e6dn:not(.rich-text-wrapper), .framer-jTQU7 .framer-styles-preset-1e4e6dn.rich-text-wrapper p {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 14px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 500;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 400;
  --framer-letter-spacing: 0;
  --framer-line-height: 1.6em;
  --framer-paragraph-spacing: 20px;
  --framer-text-alignment: start;
  --framer-text-color: #666666;
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

.ssr-variant {
  display: contents
}

.framer-Z7K0j.framer-uh5fr3, .framer-Z7K0j .framer-uh5fr3 {
  display: block
}

.framer-Z7K0j.framer-ho30r2 {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 64px;
  height: min-content;
  justify-content: flex-start;
  overflow: auto;
  padding: 48px 0;
  position: relative;
  width: 1440px
}

.framer-Z7K0j .framer-86rhfr {
  flex: none;
  height: 1px;
  left: 0;
  overflow: visible;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1
}

.framer-Z7K0j .framer-8lh8s7 {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  height: min-content;
  justify-content: flex-start;
  max-width: 1280px;
  overflow: visible;
  padding: 0 32px;
  position: relative;
  width: 100%
}

.framer-Z7K0j .framer-uzb7sv-container, .framer-Z7K0j .framer-12c3v3j-container, .framer-Z7K0j .framer-hq8nrx-container, .framer-Z7K0j .framer-1lt6y0a-container {
  flex: none;
  height: auto;
  position: relative;
  width: auto
}

.framer-Z7K0j .framer-1rmz44 {
  align-content: center;
  align-items: center;
  display: flex;
  flex: 1 0 0px;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  height: min-content;
  justify-content: flex-end;
  overflow: hidden;
  overflow-x: auto;
  padding: 0;
  position: relative;
  width: 1px
}

.framer-Z7K0j .framer-2giprb, .framer-Z7K0j .framer-109326g, .framer-Z7K0j .framer-r94jk2, .framer-Z7K0j .framer-eillf5 {
  -webkit-user-select: none;
  flex: none;
  height: auto;
  position: relative;
  user-select: none;
  white-space: pre;
  width: auto
}

.framer-Z7K0j .framer-7mlggx {
  align-content: center;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: visible;
  padding: 0 32px;
  position: relative;
  width: 100%
}

.framer-Z7K0j .framer-2pnj2j {
  align-content: center;
  align-items: center;
  display: flex;
  flex: 1 0 0px;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  height: min-content;
  justify-content: flex-end;
  max-width: 1280px;
  overflow: hidden;
  overflow-x: auto;
  padding: 0;
  position: relative;
  width: 1px
}

@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) {
  .framer-Z7K0j.framer-ho30r2, .framer-Z7K0j .framer-8lh8s7, .framer-Z7K0j .framer-1rmz44, .framer-Z7K0j .framer-7mlggx, .framer-Z7K0j .framer-2pnj2j {
    gap: 0px
  }

  .framer-Z7K0j.framer-ho30r2 > * {
    margin: 32px 0
  }

  .framer-Z7K0j.framer-ho30r2 > :first-child {
    margin-top: 0
  }

  .framer-Z7K0j.framer-ho30r2 > :last-child {
    margin-bottom: 0
  }

  .framer-Z7K0j .framer-8lh8s7 > *, .framer-Z7K0j .framer-1rmz44 > *, .framer-Z7K0j .framer-2pnj2j > * {
    margin: 0 10px
  }

  .framer-Z7K0j .framer-8lh8s7 > :first-child, .framer-Z7K0j .framer-1rmz44 > :first-child, .framer-Z7K0j .framer-7mlggx > :first-child, .framer-Z7K0j .framer-2pnj2j > :first-child {
    margin-left: 0
  }

  .framer-Z7K0j .framer-8lh8s7 > :last-child, .framer-Z7K0j .framer-1rmz44 > :last-child, .framer-Z7K0j .framer-7mlggx > :last-child, .framer-Z7K0j .framer-2pnj2j > :last-child {
    margin-right: 0
  }

  .framer-Z7K0j .framer-7mlggx > * {
    margin: 0 5px
  }
}

.framer-0tVId .framer-styles-preset-1svxohx:not(.rich-text-wrapper), .framer-0tVId .framer-styles-preset-1svxohx.rich-text-wrapper p {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 16px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 600;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 400;
  --framer-letter-spacing: 0;
  --framer-line-height: 1.6em;
  --framer-paragraph-spacing: 20px;
  --framer-text-alignment: start;
  --framer-text-color: var(--token-efb762cf-bc24-4fbd-92cb-b75ee53fdca8, #667085);
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

.framer-Nwuge .framer-styles-preset-17yh2lq:not(.rich-text-wrapper), .framer-Nwuge .framer-styles-preset-17yh2lq.rich-text-wrapper a {
  --framer-link-current-text-color: #111111;
  --framer-link-current-text-decoration: underline;
  --framer-link-hover-text-color: var(--FontColor1, #141519);
  --framer-link-hover-text-decoration: underline;
  --framer-link-text-color: var(--token-efb762cf-bc24-4fbd-92cb-b75ee53fdca8, #667085);
  --framer-link-text-decoration: none
}

.framer-Z7K0j[data-border=true]:after, .framer-Z7K0j [data-border=true]:after {
  content: "";
  border-width: var(--border-top-width, 0) var(--border-right-width, 0) var(--border-bottom-width, 0) var(--border-left-width, 0);
  border-color: var(--border-color, none);
  border-style: var(--border-style, none);
  width: 100%;
  height: 100%;
  position: absolute;
  box-sizing: border-box;
  left: 0;
  top: 0;
  border-radius: inherit;
  pointer-events: none
}

.framer-Z7K0j[data-hide-scrollbars=true]::-webkit-scrollbar, .framer-Z7K0j [data-hide-scrollbars=true]::-webkit-scrollbar {
  width: 0px;
  height: 0px
}

.framer-Z7K0j[data-hide-scrollbars=true]::-webkit-scrollbar-thumb, .framer-Z7K0j [data-hide-scrollbars=true]::-webkit-scrollbar-thumb {
  background: transparent
}

.framer-hvMep.framer-51r1cg, .framer-hvMep .framer-51r1cg {
  display: block
}

.framer-hvMep.framer-p3te6o {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: 32px;
  justify-content: flex-start;
  overflow: visible;
  padding: 0;
  position: relative;
  width: min-content
}

.framer-hvMep .framer-1winbqz {
  flex: none;
  height: 32px;
  overflow: visible;
  position: relative;
  width: 32px
}

.framer-hvMep .framer-gb2bfx {
  aspect-ratio: .8205128205128205 / 1;
  flex: none;
  height: var(--framer-aspect-ratio-supported, 39px);
  left: 0;
  position: absolute;
  right: 0;
  top: 0
}

.framer-hvMep .framer-1cva16v {
  flex: none;
  height: auto;
  position: relative;
  white-space: pre;
  width: auto
}

@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) {
  .framer-hvMep.framer-p3te6o {
    gap: 0px
  }

  .framer-hvMep.framer-p3te6o > * {
    margin: 0 5px
  }

  .framer-hvMep.framer-p3te6o > :first-child {
    margin-left: 0
  }

  .framer-hvMep.framer-p3te6o > :last-child {
    margin-right: 0
  }
}

.framer-FhEkj .framer-styles-preset-ebsdsa:not(.rich-text-wrapper), .framer-FhEkj .framer-styles-preset-ebsdsa.rich-text-wrapper p {
  --framer-font-family: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-bold-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-family-italic: "Inter", "Inter Placeholder", sans-serif;
  --framer-font-open-type-features: "blwf" on, "cv09" on, "cv03" on, "cv04" on, "cv11" on;
  --framer-font-size: 18px;
  --framer-font-style: normal;
  --framer-font-style-bold: normal;
  --framer-font-style-bold-italic: italic;
  --framer-font-style-italic: italic;
  --framer-font-variation-axes: normal;
  --framer-font-weight: 500;
  --framer-font-weight-bold: 700;
  --framer-font-weight-bold-italic: 700;
  --framer-font-weight-italic: 400;
  --framer-letter-spacing: 0;
  --framer-line-height: 1.6em;
  --framer-paragraph-spacing: 20px;
  --framer-text-alignment: start;
  --framer-text-color: #666666;
  --framer-text-decoration: none;
  --framer-text-stroke-color: initial;
  --framer-text-stroke-width: initial;
  --framer-text-transform: none
}

@supports (aspect-ratio: 1) {
  body {
    --framer-aspect-ratio-supported: auto
  }
}

.framer-00O76.framer-1psmk83, .framer-00O76 .framer-1psmk83 {
  display: block
}

.framer-00O76.framer-mjckvq {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: min-content;
  justify-content: center;
  padding: 0;
  position: relative;
  width: min-content
}

.framer-00O76 .framer-uptp4j, .framer-00O76 .framer-qa5b9b, .framer-00O76 .framer-phwham {
  flex: none;
  height: 24px;
  position: relative;
  width: 24px
}

@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) {
  .framer-00O76.framer-mjckvq {
    gap: 0px
  }

  .framer-00O76.framer-mjckvq > * {
    margin: 0 5px
  }

  .framer-00O76.framer-mjckvq > :first-child {
    margin-left: 0
  }

  .framer-00O76.framer-mjckvq > :last-child {
    margin-right: 0
  }
}
</style><!-- Start of headEnd -->

<!-- End of headEnd -->
<style type="text/css" data-framer-css="true"></style>

